import React, { useEffect, useRef, useState } from 'react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import ReqExpBanner from 'app/modules/user/newReqExpBanner/NewReqExpBanner';
import Address from './addressSection/AddressSection';
import useStore, { IStore } from 'app/store';
import ExpandIcon from 'app/static/icons/expand-icon.svg';
import CollapseIcon from 'app/static/icons/collapse-icon.svg';
import { Dialog, DialogFooter, IDropdownOption, Label, Spinner, Stack, StackItem } from '@fluentui/react';
import errorIcon from 'app/static/icons/warning-red.svg';
import './NewReqExperience.scss';
import { DefaultButton, Icon, SpinnerSize } from '@fluentui/react';
import { Link, PrimaryButton, Text, Image, TextField } from '@fluentui/react';
import { Modal } from '@fluentui/react';
import momentBusinessDays from 'moment-business-days';
import SelectDevice from 'app/modules/user/newReqExperience/selectDevice/SelectDevice';
import RequestPreview from 'app/modules/user/newReqExperience/requestPreview/RequestPreview';

import NewCustomer from 'app/modules/user/newReqExperience/newCustomer/NewCustomer';
import Customer from 'app/modules/user/newReqExperience/customer/Customer';
import Action from 'app/modules/user/newReqExperience/action/Action';
import AlternateContactDetails from 'app/modules/user/newReqExperience/alternativeContactDetails/AlternativeContactDetails';
import CartItem from './CartItem';
import { CustomField } from './customTextFields/CustomTextFields';
import ActionSection from './actionSection/ActionSection';
import { IChoiceGroupOption } from '@fluentui/react';
import { Link as LinkRoute, useHistory } from 'react-router-dom';
import ScreenBg from './ScreenBg';
import moment from 'moment';
import { useSpeechToTextToken, useSearchResult } from 'app/services/search-api';
import { MsxSuggestDocument, SearchField, SearchOption, SearchResultDocument, SearchResultDocumentResponse } from 'generated/search-backend';
import {
    useGetNewRequest,
    useRequestTypes,
    useMsxData,
    useGetRequestById,
    useGetCountries,
    useGettingRequestType,
    useSaveRequest,
} from 'app/services/request-api';
import { AttachmentDto, CountryDto, CustomerImpactDto, DeviceCategory, DeviceModel, DeviceModelDto, IRequestDto, IRouteRequest, MsxStaticData, RequestDto } from 'generated/request-backend';
import { EnumLookUp, HashTagDto } from 'generated/crew-backend';
import {
    usePostRequestType,
    usePostCommentsHashTags
} from 'app/services/mutations';
import { AddAttachments } from '../dropZone/AddAttachments';
import {
    addItemsToList,
    escapeToSafeCharacters,
    fieldValidation,
    getQuickLinksText,
    getURLForTeamAndType,
    isNumberGreaterThanZero,
    requestHelpSubmit
} from 'app/components/helpers';
import { Trans, useTranslation } from 'react-i18next';

import AddImpact from 'app/components/addCustomer/AddCustomer';
import { ReviewCustomer } from './reviewCustomer/ReviewCustomer';
import { EditorState } from 'draft-js';
import { Loader } from 'app/components/loader/Loader';
import PromptModal from './PromptModal/PromptModal';
import NavigationPrompt, { ChildData } from 'react-router-navigation-prompt';
import {
    blobStorageUpload,
    removeBlobFileSasToken,
    removeFailedBlobFiles,
    removeFailedUploadsFromAttachmentList,
    removeFailuresFromAttachedFiles,
    replaceBase64ImagesWithBlobUrl
} from 'app/utils/blobStorageHelpers';
import { IAttachment, IBlobError, IBlobUploadFile } from 'app/models/common/post';
import { appInsightsService, RouteConstants, StringConstants, TelemetryConstants } from 'app/utils/constants';
import { SEARCH_PLACEHOLDERS } from 'app/utils/searchUtilities';
import { TEAM_DETAILS } from 'app/modules/admin/contactDetails/constants';
import { debounce } from 'lodash';
import DOMPurify from 'dompurify';
import RequestFeedback, { RequestFeedbackSubmittedDetails } from 'app/components/feedback/RequestFeedback';

import * as speechSdk from 'microsoft-cognitiveservices-speech-sdk';

const timestamp = new Date();

export interface IRequestPreview {
    type?: string,
    title?: string,
    desc?: string,
    msxMatched?: Boolean,
    filteredData?: MsxSuggestDocument[],
    dateImportance?: string,
    dueDate?: string,
    impDevices?: string,
    revenueRisk?: string,
    productName?: string,
    emailID?: string,
    shippingAdd?: string,
    mobileNumber?: string,
    custEmail?: string,
    contactNum?: string,
    custShippingAddress?: string,
    cssCaseNum?: string,
    fundsDescription?: string,
    selectedDCFKey?: string,
    manualData?: Boolean,
    status?: string,
    custName?: string,
    tpid?: string,
    accountID?: string,
    customerImpactDescription?: string,
    country?: string,
    selectedIssue?: IDropdownOption,
    contactName?: string,
    newDeviceRisk?: string,
    newRevenueRisk?: string,
    mobilePrefix?: string,
    contactNumPrefix?: string
}

const RequestExperience: React.FC = () => {
    const history = useHistory();

    const searchContainer = useRef<HTMLDivElement>(null);
    const { t: translate } = useTranslation();
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [descEditorState, setDescEditorState] = useState(EditorState.createEmpty());
    const [originalSelected, setOriginalSelected] = useState<MsxSuggestDocument[]>([]);

    const [customerSearchInput, setCustomerSearchInput] = useState('');
    const [customerSelected, setCustomerSelected] = useState(false);
    const [requestTypeFlow, setRequestTypeFlow] = useState(null);
    const addFiles = useStore((state: IStore) => state.addFiles);
    const attachedFiles = useStore((state: IStore) => state.attachedFiles);
    const setRedirectRequestType = useStore((state: IStore) => state.setRedirectRequestType);
    const requestStartTime = useRef<Date>(new Date());

    const quickLinksID = useStore((state: IStore) => state.quickLinksID);
    const setQuickLinksID = useStore((state: IStore) => state.setQuickLinksID);
    const redirectRequestType = useStore((state: IStore) => state.redirectRequestType);
    const setQuickLinksFLow = useStore((state: IStore) => state.setQuickLinksFLow);
    const quickLinksFLow = useStore((state: IStore) => state.quickLinksFLow);
    const [shrinkAnimation, setShrinkAnimation] = useState(false);
    const [requestSection, setRequestSection] = useState('selectDevice');
    const [requestOptions, setRequestOptions] = useState<EnumLookUp[]>([]);
    const [requestType, setRequestType] = useState('');
    const [lastSelectedCustomerName, setLastSelectedCustomerName] = useState('');
    const [selectedRequestType, setSelectedRequestType] = useState('');
    const clearFiles = useStore((state: IStore) => state.clearFiles);
    const quickLinksValue = useStore((state: IStore) => state.quickLinksValue);
    const setQuickLinksValue = useStore((state: IStore) => state.setQuickLinksValue);
    const setOriginalRoutingML = useStore((state: IStore) => state.setOriginalRoutingML);
    const originalRoutingML = useStore((state: IStore) => state.originalRoutingML);
    const [addModelHText, setAddModelHText] = useState(false);
    const [addProductHText, setAddProductHText] = useState(false);
    const userDetails = useStore((state: IStore) => state.accountDetails.name);
    const [manualData, setManualData] = useState(false);
    const [customerEmail, setCustomerEmail] = useState('');
    const [contactNum, setContactNum] = useState('');
    const [customerShippingAddress, setCustomerShippingAddress] = useState('');
    const [currentSection, setCurrentSection] = useState('landing');
    const [searchNotFound, setSearchNotFound] = useState(false);
    const [tempFlow, setTempFlow] = useState(null);
    const [newRevenueRisk, setNewRevenueRisk] = useState('');
    const [newDeviceRisk, setNewDeviceRisk] = useState('');
    const [issueHText, setIssueHText] = useState(false);
    const [selectedIssue, setSelectedIssue] = useState<IDropdownOption>();
    const [customerEmailHText, setCustomerEmailHText] = useState(false);
    const [contactNumHText, setContactNumHText] = useState(false);
    const [customerShippingAddHText, setCustomerShippingAddHText] = useState(false);
    const [msxOpportunityId, setMsxOpportunityId] = useState('');
    const [msxStatus, setMsxStatus] = useState('');
    const [customerTPID, setCustomerTPID] = useState('');
    const [customerTPIDHText, setCustomerTPIDHText] = useState(false);
    const [customerName, setCustomerName] = useState('');
    const [customerAccountID, setCustomerAccountID] = useState('');
    const [customerAccountIDHText, setCustomerAccountIDHText] = useState(false);
    const [country, setCountry] = useState('');
    const [cssCaseNum, setCSSCaseNum] = useState('');
    const [filteredData, setFilteredData] = useState<MsxSuggestDocument[]>([]);
    const [msxMatched, setMSXMatched] = useState(false);
    const [msxNotMatched, setMSXNotMatched] = useState(false);
    const [revenueRisk, setRevenueRisk] = useState('');
    const [impDevices, setImpDevices] = useState('');
    const [showSuggestion, setShowSuggestion] = React.useState(false);
    const [suggest, setSuggest] = React.useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [toggleSearch, setToggleSearch] = React.useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [newRequest, setNewRequest] = React.useState(false);

    // Rich text states
    const [requestDesc, setRequestDesc] = useState('');
    const [requestDescriptionToSubmit, setRequestDescriptionToSubmit] = useState<string>('');

    const [customerAltPage, setCustomerAltPage] = React.useState(false);
    const [mobileNumber, setMobileNumber] = useState('');
    const [emailID, setEmailID] = useState('');
    const [shippingAdd, setShippingAdd] = useState('');

    // Rich text states
    const [dateImportance, setDateImportance] = useState('');
    const [dateImportanceToSubmit, setDateImportanceToSubmit] = useState<string>('');

    const [selectedDCFKey, setSelectedDCFKey] = React.useState<string | undefined>();

    const [titleHText, setTitleHText] = useState(false);
    const [descHText, setDescHText] = useState(false);
    const [autoSuggestHText, setAutoSuggestHText] = useState(false);
    const [revenueHText, setRevenueHText] = useState(false);
    const [impDevicesHText, setImpDevicesHText] = useState(false);
    const [dateImportanceHText, setDateImportanceHText] = useState(false);
    const [emailHText, setEmailHText] = useState(false);
    const [caseNumHText, setCaseNumHText] = useState(false);
    const [previewHText, setPreviewHText] = useState(false);
    const [emailValidText, setEmailValidText] = useState(false);
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [hideCancelConfirmationDialog, { toggle: toggleCancelConfirmationDialog }] = useBoolean(true);
    const today = new Date(Date.now());
    today.setDate(today.getDate() + 1);
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 2);
    const { mutate: draftSaveRequest, isSuccess: draftSaveSuccess } = useSaveRequest();
    const { data: draftRequest, isLoading, isSuccess: isGetDraftSuccess } = useGetNewRequest();
    const { data: countryList } = useGetCountries();
    const [mobNumValidText, setMobNumValidText] = useState(false);
    const [revenueValidText, setRevenueValidText] = useState(false);
    const [impDevicesValidText, setImpDevicesValidText] = useState(false);
    const [attachmentList, setAttachmentList] = useState<IAttachment[]>([]);

    const [customerImpactDescription, setCustomerImpactDescription] = useState('');
    const [impactsHText, setImpactsHText] = useState(false);

    const [customerNameHText, setCustomerNameHText] = useState(false);
    const [contactName, setContactName] = useState('');
    const [contactNameHText, setContactNameHText] = useState(false);

    const [tempDescriptionValue, setTempDescriptionValue] = useState('');
    const [tempDateImportanceValue, setTempDateImportanceValue] = useState('');
    const [noQuickLinksSelected, setNoQuickLinksSelected] = useState(false);
    const [tempQuickLinkID, setTempQuickLinkID] = useState(null);
    const [countryHText, setCountryHText] = useState(false);

    const [successMsg, setSuccessMsg] = useState(false);
    // Telemetry state
    const [feedbackSubmitted, setFeedbackSubmitted] = useState<boolean>(false);
    const [selectedProductId, setSelectedProductId] = useState<number>();
    const [fundsDescription, setFundDescription] = useState('');
    const [selectedProductName, setSelectedProductName] = useState('');
    const [modelsList, setModelsList] = useState<DeviceModelDto[]>([]);
    const [selectedModel, setSelectedModel] = useState<DeviceModelDto[]>([]);
    const [selectedDate, setSelectedDate] = useState(momentBusinessDays().businessAdd(7).toDate());
    const [dateSent, setDateSent] = useState(momentBusinessDays().businessAdd(7).toISOString());
    const [pageLoadAnimation, setPageLoadAnimation] = useState(true);
    const [hideSearch, setHideSearch] = useState(false);
    const [recognizer, setRecognizer] = useState(null);
    const [animateReviewCustomer, setAnimateReviewCustomer] = useState('');
    const [animateTitle, setAnimateTitle] = useState('');
    const [animateDescription, setAnimateDescription] = useState('');
    const [animateCustomer, setAnimateCustomer] = useState('');
    const [animateNewCustomer, setAnimateNewCustomer] = useState('');
    const [animateAction, setAnimateAction] = useState('');
    const [animateDCFAction, setAnimateDCFAction] = useState('');
    const [animateAddress, setAnimateAddress] = useState('');
    const [animateAttachments, setAnimateAttachments] = useState('');
    const [animatePreview, setAnimatePreview] = useState('');
    const [dcfBtnHText, setDCFBtnHText] = useState(false);
    const [fundHText, setFundHText] = useState(false);
    const [cartHText, setCartHText] = useState(false);
    const [animateStep, setAnimateStep] = useState('');
    const [animateStepReverse, setAnimateStepReverse] = useState('');
    const [fullReverse, setFullReverse] = useState(false);
    const [cartState, setCartState] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [quickLinksChange, setQuickLinksChange] = useState(false);
    const [msxData, setMsxData] = useState<MsxStaticData[]>([]);
    const [errorMsg, setErrorMsg] = useState(false);
    const [isRecording, setIsRecording] = useState(false);

    const [suggestResult, setSuggestResult] = useState<Array<SearchResultDocumentResponse>>([]);

    const [addCusModal, setAddCusModal] = useState<RequestDto>(new RequestDto({}));
    const [customerInputType, setCustomerInputType] = useState('search');
    const addSuccessPopUp = useStore((state: IStore) => state.addSuccessPopUp);
    const [isModalOpenCus, { setTrue: showModalCus, setFalse: hideModalCus }] = useBoolean(false);
    const titleId = useId('title');
    const searchFieldRef = useRef(null);
    const { mutate: searchData, data: searchResultData, isSuccess: isSuccessSearch } = useSearchResult();

    // State variables for addCustomer
    const [requestProcessing, setRequestProcessing] = useState(false);
    const [displayScreen, setDisplayScreen] = useState('searchCust');

    const { data: requestTypesData, isLoading: requestLoading } = useRequestTypes();
    const { data: msxListData, isLoading: isMSXListDataLoading } = useMsxData();

    const {
        data: responseRequestType,
        mutate: gettingRequestType,
        isLoading: isGettingRequestType,
        isSuccess: successRequestType,
        isError: errorRequestType
    } = useGettingRequestType();
    const [mobilePrefix, setMobilePrefix] = useState<string>(null);
    const [isCancelCLicked, setIsCancelClicked] = useState(false);
    const { refetch: getSpeechToTextToken } = useSpeechToTextToken();
    const {
        mutate: postRequestTypeHelp,
        isSuccess: successPostRequestHelp,
        isError: errorPostRequestHelp,
        isLoading: isCreatingRequest,
        data: postRequestResponse
    } = usePostRequestType();

    const [postSKPId, setPostSKPId] = useState('');
    const [contactNumPrefix, setContactNumPrefix] = useState(null);

    // blob upload helpers
    const [readyToUploadFiles, setReadyToUploadFiles] = useState(false);
    const [blobUploadFiles, setBlobUploadFiles] = useState<IBlobUploadFile[]>([]);
    const [isUplodingToBlob, setIsUplodingToBlob] = useState(false);
    const [uploadErrors, setUploadErrors] = useState<IBlobError[]>([]);
    const handleMainModalDismiss = React.useCallback(() => {
        if (!customerAltPage && !isCreatingRequest) {
            draftSaveRequest(JSON.stringify({}));
            appInsightsService.logEvent('FeedbackModalDismissed', {
                requestId: String(postSKPId),
                feedbackSubmitted: String(feedbackSubmitted)
            });
            history.push(RouteConstants.KNOWLEDGE_PORTAL);
        } else {
            hideModal();
        }
    }, [customerAltPage, isCreatingRequest, draftSaveRequest, history, hideModal, feedbackSubmitted, postSKPId]);
    // upload attachments to blob storage
    const handleUploadAttachments = async () => {
        setUploadErrors([]);

        if (attachmentList.length === 0) {
            return false;
        }

        let successfulAttachments: IAttachment[] = [];
        setIsUplodingToBlob(true);
        let uploadStartTime = Date.now();
        logRequestflowTelemetry(TelemetryConstants.POP_UPLOAD_STARTED, { "file_count": String(attachmentList.length) });
        if (blobUploadFiles.length > 0) {
            // send files to blobstorage service
            await blobStorageUpload(blobUploadFiles).then((res) => {
                let errors = res.length > 0 ? true : false;
                if (errors) {
                    setUploadErrors(res);
                    // remove failed files from attachments
                    successfulAttachments = removeFailedUploadsFromAttachmentList(res, attachmentList);
                    logRequestflowTelemetry(TelemetryConstants.POP_UPLOAD_FAILED,
                        {
                            "error_messages": res.map(error => error.error).join(", "),
                            "extension": attachmentList.map(att => att.type).join(", ")
                        });
                }
                // update attachmentList with only successful attachments
                setAttachmentList(successfulAttachments.length > 0 ? successfulAttachments : attachmentList);
                //remove error files from blobUploadFiles
                setBlobUploadFiles(removeFailedBlobFiles(blobUploadFiles, attachmentList));
                if (blobUploadFiles.length > 0) {
                    logRequestflowTelemetry(TelemetryConstants.POP_UPLOAD_SUCCESSFUL,
                        {
                            "sizes": blobUploadFiles.map(att => att.file.size).join(", "),
                            "file_count": String(blobUploadFiles.length),
                            "upload_time_ms": String(Date.now() - uploadStartTime)
                        });
                }
            });

            // update attachedFiles with only succesful attachments
            addFiles(removeFailuresFromAttachedFiles(attachmentList, attachedFiles as IAttachment[]));
        }

        setIsUplodingToBlob(false);
        setReadyToUploadFiles(false);
        setBlobUploadFiles([]);
    };

    const addToBlobUploadFiles = (newBlobFiles: IBlobUploadFile[]) => {
        setBlobUploadFiles(addItemsToList(blobUploadFiles, newBlobFiles));
    };

    useEffect(() => {
        if (attachmentList.length < 1) {
            setIsUplodingToBlob(false);
        }
    }, [blobUploadFiles]);

    const handleSuggestionClose = () => {
        setShowSuggestion(false);
    };

    const onIssueChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
        setIssueHText(false);
        setSelectedIssue(item);
    };

    useEffect(() => {
        if (isCancelCLicked) {
            history.push(RouteConstants.KNOWLEDGE_PORTAL);
            goBackToInitial('search');
            toggleHideDialog();
        }
    }, [draftSaveSuccess]);

    useEffect(() => {
        if (isCancelCLicked) {
            draftSaveRequest(JSON.stringify({}));
        }
    }, [isCancelCLicked]);

    useEffect(() => {
        if (successRequestType) {
            toggleHideDialog();
            const requestType = responseRequestType?.toJSON().requestType;
            if (requestType !== requestTypeFlow) {
                setRequestTypeFlow(requestType);
                setTempFlow(requestType);
            }
            if (requestType > 7 && requestType < 13) {
                setRequestType(StringConstants.IRT);
            } else if (
                (requestType > 12 && requestType < 16) ||
                requestType === 5
            ) {
                setRequestType(StringConstants.POST_SALES);
            } else {
                requestOptions.forEach((item: EnumLookUp) => {
                    if (item.id === requestType) {
                        setRequestType(item.name);
                    }
                });
            }
        } else if (errorRequestType) {
            toggleHideDialog();
        }
    }, [successRequestType, isGettingRequestType, requestOptions, responseRequestType, errorRequestType]);
    useSearchSuggestionClose(searchContainer, handleSuggestionClose);

    const [hashTagsFormatted, setHashTagsFormatted] = useState<HashTagDto[]>([]);
    const { mutate: postHashTags } = usePostCommentsHashTags();

    useEffect(() => {
        if (successPostRequestHelp) {
            setCustomerAltPage(false);
            setSuccessMsg(true);
            setErrorMsg(false);
            setPostSKPId(postRequestResponse);
            appInsightsService.logEvent('RequestSuccessModalShown', {
                requestId: String(postRequestResponse ?? ''),
            });

            if (selectedRequest) {
                let url = getURLForTeamAndType(selectedRequest.requestTeam, selectedRequest.requestType);
                if (Array.isArray(hashTagsFormatted) && hashTagsFormatted?.length > 0) {
                    postHashTags({ url: url, data: hashTagsFormatted, id: selectedRequest.unifiedTrackingId });
                }
            }
        } else if (errorPostRequestHelp) {
            setErrorMsg(true);
            setCustomerAltPage(false);
            setSuccessMsg(true);
        }
    }, [successPostRequestHelp, errorPostRequestHelp, showModal]);

    useEffect(() => {
        if (successRequestType) {
            setTimeout(function () {
                setCurrentSection('reqDetailsPage');
                setRequestSection('selectDevice');
            }, 300);
        }
    }, [errorRequestType, successRequestType, isGettingRequestType]);

    useEffect(() => {
        if (!requestLoading) {
            setRequestOptions(requestTypesData);
        }
        if (!isMSXListDataLoading) {
            setMsxData(msxListData);
        }
    }, [requestLoading, isMSXListDataLoading, msxListData, requestTypesData]);

    useEffect(() => {
        if (isSuccessSearch) {
            setSuggestResult(searchResultData?.searchResult?.items);
        }
    }, [isSuccessSearch]);

    // add debounce to avoid multiple search requests in the backend as user is typing
    const debounceSearch = React.useCallback(debounce(searchData, 300), []);

    useEffect(() => {
        if (searchValue.trim().length > 0 && currentSection === 'landing') {
            debounceSearch({
                searchTerm: escapeToSafeCharacters(searchValue),
                pageIndex: 1,
                pageSize: 3,
                searchOption: SearchOption.HelpRequest,
                searchField: SearchField.Default,
                orderBy: [],
                isAdminSearch: false
            });
        }
    }, [searchValue]);
    useEffect(() => {
        if (quickLinksID && !tempQuickLinkID && noQuickLinksSelected) {
            if (currentSection === 'landing') {
                setTempQuickLinkID(quickLinksID);
                goBackToInitial('search');
            } else {
                toggleHideDialog();
                setQuickLinksChange(true);
            }
        }
    }, [quickLinksID]);

    useEffect(() => {
        if (quickLinksID !== tempQuickLinkID && quickLinksID && tempQuickLinkID) {
            if (currentSection === 'landing') {
                setTempQuickLinkID(quickLinksID);
                goBackToInitial('search');
            } else {
                toggleHideDialog();
                setQuickLinksChange(true);
            }
        }
    }, [quickLinksID, tempQuickLinkID]);
    useEffect(() => {
        if (currentSection !== 'landing') {
            submitDraftData();
        }
        logRequestflowTelemetry(TelemetryConstants.REQUEST_STEP_ENTRY);
    }, [currentSection, requestSection]);

    // removeDuplicates is not currently being used
    // function removeDuplicates(array: any) {
    //     let a: any = [];
    //     array.forEach((x: any) => {
    //         if (!a.includes(x)) {
    //             a.push(x);
    //         }
    //     });

    //     return a;
    // }
    useEffect(() => {
        if (!isModalOpenCus) {
            setShowSuggestion(false);
            setSearchValue('');
            setSuggestResult([]);
        }
    }, [isModalOpenCus]);
    useEffect(() => {
        if (requestTypeFlow && tempFlow) {
            goBackToInitial('new request type');
        }
    }, [requestTypeFlow]);
    useEffect(() => {
        let navType: PerformanceNavigationTiming = performance?.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        if (
            !isLoading &&
            isGetDraftSuccess &&
            navType &&
            (navType.type === 'reload' || navType.type === 'navigate') &&
            !quickLinksValue &&
            redirectRequestType === ''
        ) {
            if (draftRequest && Object.entries(draftRequest).length !== 0) {
                setDraftData(draftRequest);
            } else clearFiles();
        }
    }, [isLoading, isGetDraftSuccess]);

    const onBtnChange = React.useCallback((ev: React.SyntheticEvent<HTMLElement>, option: IChoiceGroupOption) => {
        setSelectedDCFKey(option.key);
        setDCFBtnHText(false);
    }, []);

    const setAddress = (value: string, type: string) => {
        switch (type) {
            case 'EMAIL':
                setCustomerEmail(value);
                setCustomerEmailHText(false);
                break;
            case 'CONTACT_NUMBER':
                setContactNum(value);
                setContactNumHText(false);
                break;
            case 'ADDRESS':
                setCustomerShippingAddress(value);
                setCustomerShippingAddHText(false);
                break;
            case 'CUSTOMER_NAME':
                setContactName(value);
                setContactNameHText(false);
                break;
            case 'CONTACT_NUMBER_PREFIX':
                setContactNumPrefix(value);
                if (contactNum) setContactNumHText(false);
                break;
            default:
                break;
        }
    };
    const setAction = (value: string) => {
        setFundDescription(value);
        setFundHText(false);
    };
    const [requestId, setRequestId] = useState('');

    // queries
    const {
        data: apiRequestData,
        isLoading: isLoadingRequestList,
        refetch: refetchRequestDetails
    } = useGetRequestById(requestId);
    const [selectedRequest, setSelectedRequest] = useState<RequestDto>();

    useEffect(() => {
        if (!isLoadingRequestList && apiRequestData && apiRequestData) {
            setSelectedRequest(apiRequestData);
        }
    }, [apiRequestData, isLoadingRequestList]);

    useEffect(() => {
        setTempQuickLinkID(quickLinksID);
        if (!quickLinksID) {
            setNoQuickLinksSelected(true);
        }
    }, []);

    useEffect(() => {
        if (recognizer == null) {
            return;
        }
        if (isRecording) {
            appInsightsService.logStartTimedEvent(TelemetryConstants.VOICE_SEARCH_DURATION);
        } else {
            appInsightsService.logStopTimedEvent(TelemetryConstants.VOICE_SEARCH_DURATION);
        }
    }, [isRecording]);

    const deviceSelected = (item: DeviceCategory) => {
        if (selectedProductId !== item.id) {
            setAddProductHText(false);
            setAddModelHText(false);
            setCartHText(false);
            setSelectedProductId(item.id);
            setSelectedProductName(item.name);
            let ar = [...item.devices];
            let ex: DeviceModelDto[] = [];
            ar.forEach((ele: DeviceModelDto) => {
                let it = new DeviceModelDto();
                if (selectedModel.length === 0) {
                    it = ele;
                    ex.push(it);
                } else {
                    selectedModel.every((em: DeviceModelDto) => {
                        if (em.id === ele.id) {
                            it = em;
                            return false;
                        } else {
                            it = ele;
                            return true;
                        }
                    });
                    ex.push(it);
                }
            });

            setModelsList(ex);
        } else {
            setSelectedProductId(undefined);
            setSelectedProductName('');
            let ex: DeviceModelDto[] = [];
            selectedModel.forEach((ele) => {
                let flag = false;
                item.devices.every((it: DeviceModel) => {
                    if (it.id === ele.id) {
                        flag = true;
                        return false;
                    } else {
                        return true;
                    }
                });
                if (!flag) {
                    ex.push(ele);
                }
            });
            setSelectedModel(ex);
        }
    };

    const modelSelected = (item: DeviceModelDto, categoryIdVal: number) => {
        if (selectedModel.indexOf(item) === -1) {
            setAddProductHText(false);
            setAddModelHText(false);
            setCartHText(false);
            item.categoryId = categoryIdVal;
            let newItem = [...selectedModel, item];
            setSelectedModel(newItem);
        } else {
            const i = selectedModel.indexOf(item);
            if (!selectedModel[i].isAdded) {
                let ar = [...selectedModel];
                ar.splice(i, 1);
                setSelectedModel(ar);
            }
        }
        logRequestflowTelemetry(TelemetryConstants.MODELS_ADD_CLICKED, {
            model_name: String(item.name),
            category_id: String(categoryIdVal)
        });
    };
    const onCountChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        selectedModel.forEach((ele: DeviceModelDto, index) => {
            if (ele.name === (e.target as HTMLInputElement | HTMLTextAreaElement).name) {
                selectedModel[index].count = parseInt((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                selectedModel[index].deviceCount = parseInt((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                logRequestflowTelemetry(TelemetryConstants.MODELS_UPDATE_CLICKED, {
                    model_name: String(ele.name),
                    new_count: String(ele.count)
                });
            }
        });
        setSelectedModel([...selectedModel]);
        setAddModelHText(false);
        setCartHText(false);
    };

    const removeSelectedModel = (item: DeviceModelDto) => {
        const i = selectedModel.indexOf(item);
        let eg = [...selectedModel];
        eg[i].isAdded = false;
        setSelectedModel(eg);
        let itemRemoved = selectedModel.filter((el) => el.id !== item.id);
        setSelectedModel([...itemRemoved]);
    };

    const getRequestType = () => {
        toggleHideDialog();
        const routeRequest: IRouteRequest = {
            title: searchValue,
            description: requestDescriptionToSubmit.length > 0 ? requestDescriptionToSubmit : requestDesc,
            requestDomain: quickLinksValue
        }
        gettingRequestType(routeRequest);
    };

    let datapass: IRequestDto = {
        summary: searchValue,
        description: requestDescriptionToSubmit.length > 0 ? requestDescriptionToSubmit : requestDesc,
        requestedResolutionDate: new Date(dateSent),
        whyThisDateIsImportant: dateImportanceToSubmit.length > 0 ? dateImportanceToSubmit : dateImportance,
        hashTags: hashTagsFormatted,
        status: 1,
        attachments: attachmentList.map((attachment) => new AttachmentDto({ ...attachment })),
        customerImpacts: [
            new CustomerImpactDto({
                opportunityId: manualData ? '' : filteredData[0]?.opportunityNumber,

                customerName: manualData ? customerName : filteredData[0]?.accountName,

                tpId: manualData ? '' : filteredData[0]?.customerTPID,

                status: manualData ? '' : filteredData[0]?.status,

                customerCountry: new CountryDto({
                    id: 1,
                    name: manualData ? country : filteredData[0]?.country
                }),

                customerImpactDescription: customerImpactDescription,

                deviceCount: manualData
                    ? parseInt(newDeviceRisk?.replaceAll(',', ''))
                    : parseInt(impDevices?.replaceAll(',', '')) === filteredData[0]?.totalDeviceCount
                        ? null
                        : parseInt(impDevices?.replaceAll(',', '')),
                revenue: manualData
                    ? parseFloat(newRevenueRisk?.replace('$', '').replaceAll(',', ''))
                    : parseFloat(revenueRisk?.replace('$', '').replaceAll(',', '')) === filteredData[0]?.estimatedValue
                        ? null
                        : parseFloat(revenueRisk?.replace('$', '').replaceAll(',', '')),
                msxDeviceCount: manualData ? 0 : filteredData[0]?.totalDeviceCount,
                msxRevenue: manualData ? 0 : filteredData[0]?.estimatedValue,
                accountId: manualData ? '' : filteredData[0]?.accountNumber,
                msxOpportunityId: manualData ? '' : filteredData[0]?.opportunityId
            })
        ],
        originalRoutingML: originalRoutingML
    };

    const submitClick = async () => {
        appInsightsService.logEvent('CreateRequestClick', {
            requestType: String(requestType),
            section: String(requestSection),
            hasAttachments: String((attachmentList?.length ?? 0) > 0),
        });
        draftSaveRequest(JSON.stringify({}));

        if (!manualData) {
            let impact = datapass.customerImpacts[0];
            datapass = {
                ...datapass,
                customerImpacts: [
                    new CustomerImpactDto({
                        ...impact,
                        state: filteredData[0].region,
                        city: filteredData[0].city,
                        zipCode: filteredData[0].postalCode
                    })
                ]
            };
        }

        // must remove sas tokens from properties before saving.
        datapass.description = removeBlobFileSasToken(datapass.description);
        datapass.whyThisDateIsImportant = removeBlobFileSasToken(datapass.whyThisDateIsImportant);

        // Users are currently capable of pasting direct images in both the description and the whyThisDateIsImportant field. This can cause issues later by making the request file too large.
        datapass.description = await replaceBase64ImagesWithBlobUrl(datapass.description);
        datapass.whyThisDateIsImportant = await replaceBase64ImagesWithBlobUrl(datapass.whyThisDateIsImportant);

        const requestHelpData = requestHelpSubmit(
            requestTypeFlow,
            datapass,
            // requestType,
            selectedModel,
            searchValue,
            emailID,
            filteredData,
            cssCaseNum,
            selectedDCFKey,
            fundsDescription,
            originalRoutingML,
            contactName,
            contactNum,
            customerEmail,
            customerShippingAddress,
            manualData ? customerName : filteredData[0]?.accountName,
            manualData ? country : filteredData[0]?.country,
            mobileNumber,
            contactNumPrefix,
            mobilePrefix
        );
        postRequestTypeHelp({ subUrl: requestHelpData.subUrl, data: requestHelpData.data });
        setCustomerAltPage(false);
        showModal();
        setOriginalRoutingML(null);
    };

    const goBackToInitial = (dest: string) => {
        if (dest !== 'search' && dest !== 'new request type') {
            setRedirectRequestType('');
            setTempQuickLinkID(null);
            setQuickLinksID(null);
            setQuickLinksFLow(null);
            setQuickLinksValue(null);
            setOriginalRoutingML(null);
        }

        setMSXMatched(false);
        setMSXNotMatched(false);

        setAnimateAttachments('');
        clearFiles();
        requestStartTime.current = new Date();

        setAnimatePreview('');
        setCSSCaseNum('');
        setEmailID('');
        setMobileNumber('');
        setShippingAdd('');

        setAnimateCustomer('');
        setNewDeviceRisk('');
        setNewRevenueRisk('');
        setRevenueRisk('');
        setImpDevices('');
        setCustomerSearchInput('');
        setCustomerSelected(false);
        setFilteredData([]);

        setAnimateNewCustomer('');
        setCustomerName('');
        setCountry('');
        setMsxOpportunityId('');
        setMsxStatus('');
        setCustomerTPID('');
        setCustomerAccountID('');

        setCustomerImpactDescription('');

        setManualData(false);

        setContactNumPrefix(null);
        setAnimateAddress('');
        setContactName('');
        setCustomerEmail('');
        setContactNum('');
        setCustomerShippingAddress('');

        setAnimateAction('');
        setDateImportance('');
        setDateImportanceToSubmit('');
        setTempDateImportanceValue('');
        setSelectedIssue(undefined);
        setSelectedDate(momentBusinessDays().businessAdd(7).toDate());
        setDateSent(momentBusinessDays().businessAdd(7).toISOString());

        setAnimateDCFAction('');
        setFundDescription('');
        setSelectedDCFKey(undefined);

        setCartState(false);
        setSelectedModel([]);
        setSelectedProductId(undefined);
        setSelectedProductName('');
        setModelsList([]);

        setSuccessMsg(false);
        setErrorMsg(false);

        if (dest !== 'new request type') {
            setShowSuggestion(false);
            setSuggest(false);
            setSearchValue('');
            setShowPrompt(false);
            setRequestDesc('');
            setRequestDescriptionToSubmit('');
            setTempDescriptionValue('');
        }

        if (dest === 'new request') {
            setNewRequest(true);
            setCurrentSection('titleSearchField');
            setRequestSection('selectDevice');
        } else if (dest === 'new request type') {
            setNewRequest(true);
        } else {
            setNewRequest(false);
        }

        if (dest === 'search') {
            setRequestSection('selectDevice');
            setCurrentSection('landing');
        }
    };

    const prepareSearch = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setSearchValue((e.target as HTMLInputElement | HTMLTextAreaElement).value);

        if ((e.target as HTMLInputElement | HTMLTextAreaElement).value.trim() === '') {
            setSuggest(false);
            setShowPrompt(true);
        } else {
            setSuggest(true);
            setShowPrompt(false);
        }
    };
    const handleFocus = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setShowSuggestion(true);
        if (searchValue.trim() === '') {
            setShowPrompt(true);
            setSuggest(false);
        } else {
            setSuggest(true);
        }
        // log the search bar focus event
        appInsightsService.logEvent("SearchBarFocus: focused on search bar");
    };
    const suggestionCancel = () => {
        setShowPrompt(false);
        setShowSuggestion(false);
        setPageLoadAnimation(false);
        logRequestflowTelemetry(TelemetryConstants.SEARCH_SUGGESTION_CANCEL_CLICKED);
    };
    const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        appInsightsService.logEvent("SearchEnded: ended the search");
    };

    const setExpandVar = (id: string, type: boolean) => {
        let arr: Array<ExpandableSearchResultDocumentResponse> = [];
        if (type === undefined || !type) {
            suggestResult.forEach((ele: SearchResultDocumentResponse) => {
                const response = new ExpandableSearchResultDocumentResponse({ ...ele });
                if (ele.document.unifiedTrackingId === id) {
                    response.expanded = true;
                    arr.push(response);
                } else {
                    response.expanded = false;
                    arr.push(response);
                }
            });
        } else if (type) {
            suggestResult.forEach((ele: SearchResultDocumentResponse) => {
                const response = new ExpandableSearchResultDocumentResponse({ ...ele });
                if (ele.document.unifiedTrackingId === id) {
                    response.expanded = false;
                    arr.push(response);
                } else {
                    arr.push(response);
                }
            });
        }

        setSuggestResult(arr);
    };

    // Currently not being used
    // const renderSuggestion = (suggestion: any) => {
    //     return <div>{suggestion.id}</div>;
    // };
    // const getSuggestionValue = (suggestion: any) => {
    //     return suggestion.id;
    // };

    const addToCart = (item: DeviceModelDto) => {
        setAddProductHText(false);
        setAddModelHText(false);
        setCartHText(false);
        if (
            item.count === undefined ||
            item.count === 0 ||
            !fieldValidation(item.count.toString(), 'number', selectedModel)
        ) {
            setCartHText(
                item.count === undefined
                    ? true
                    : item.count === undefined || item.count === 0 || !fieldValidation(item.count.toString(), 'number', selectedModel)
                        ? true
                        : false
            );
        } else {
            const i = modelsList.indexOf(item);
            let eg = [...modelsList];
            eg[i].isAdded = true;
            setModelsList(eg);
        }
    };

    const setInitialState = () => {
        setHideSearch(false);
        setAnimateCustomer('');
        setAnimateNewCustomer('');
        setAnimateAction('');
        setAnimateAttachments('');
        setAnimatePreview('');
        setAnimateDescription('');
        setAnimateTitle('');
        setAnimateDCFAction('');
        setAnimateAddress('');
    };

    const addMoreDevices = () => {
        setTimeout(() => {
            setRequestSection('selectDevice');
        }, 300);
        setAnimateAttachments('A_TO_RIGHT');
        setCartState(false);
        setAnimateStep('STEP_3');
        setAnimateStepReverse('STEP_3');
    };

    const sttFromMic = async (action: boolean) => {
        if (action) {
            try {
                let token = JSON.parse(sessionStorage.getItem('speech-token'));
                if (!(token && token.Token)) {
                    await getSpeechToTextToken();
                    token = JSON.parse(sessionStorage.getItem('speech-token'));
                }
                const speechConfig = speechSdk.SpeechConfig.fromAuthorizationToken(token?.Token ?? '', token?.Region ?? '');
                speechConfig.speechRecognitionLanguage = 'en-US';
                const audioConfig = speechSdk.AudioConfig.fromDefaultMicrophoneInput();
                let newRecognizer = new speechSdk.SpeechRecognizer(speechConfig, audioConfig);
                setRecognizer(newRecognizer);
                setIsRecording(true);
                newRecognizer.recognized = function (s: speechSdk.Recognizer, e: speechSdk.SpeechRecognitionEventArgs) {
                    let displayText;

                    if (e.result.text) {
                        displayText = `${e.result.text}`;
                        displayText = displayText.substring(0, displayText.length - 1);
                        setSearchValue(displayText);
                        setIsRecording(false);
                        searchFieldRef.current.focus();

                        newRecognizer.stopContinuousRecognitionAsync(
                            () => { },
                            (e: string) => { }
                        );
                    }
                };

                newRecognizer.startContinuousRecognitionAsync(() => {
                    setTimeout(() => {
                        newRecognizer.stopContinuousRecognitionAsync(
                            () => { },
                            (e: string) => { }
                        );
                        setIsRecording(false);
                    }, 20000);
                });
            } catch (e) {
                console.error('Speech recognition failed to initialize:', e);
                setIsRecording(false);
            }
        }

        if (!action) {
            recognizer.stopContinuousRecognitionAsync(
                (result: string) => { },
                (e: string) => { }
            );
        }
    };

    const voiceSearchOn = () => {
        sttFromMic(true);
    };

    const voiceSearchOff = () => {
        setIsRecording(false);
        sttFromMic(false);
    };

    const onDetailsClicked = () => {
        if (requestSection === 'selectDevice' || requestSection === 'action' || requestSection === 'DCF_ACTION')
            setTimeout(function () {
                setShrinkAnimation(true);
                setCurrentSection('titleSearchField');
            }, 300);
    };
    const onSelectDeviceClicked = () => {
        if (requestSection === 'action' || requestSection === 'DCF_ACTION') {
            setTimeout(function () {
                setRequestSection('selectDevice');
            }, 300);
        }
    };

    const onCustomerClicked = () => {
        setTimeout(() => {
            if (manualData) {
                setAnimateNewCustomer('S_TO_NEXT');
                setRequestSection('newCustomer');
                logRequestflowTelemetry(TelemetryConstants.CREATE_NEW_CUSTOMER_CLICKED);
            } else {
                setAnimateCustomer('S_TO_NEXT');
                setRequestSection('customer');
            }
        }, 300);
    };

    const selectFirstTab = () => {
        if (
            requestSection === 'customer' ||
            requestSection === 'newCustomer' ||
            requestSection === 'address' ||
            requestSection === 'attachment' ||
            requestSection === 'preview'
        )
            setTimeout(function () {
                setCartState(false);
                setShrinkAnimation(true);
                setCurrentSection('titleSearchField');
            }, 300);
    };
    const selectSecondTab = () => {
        if (requestSection === 'attachment' || requestSection === 'preview') onCustomerClicked();
    };
    const selectThirdTab = () => {
        if (requestSection === 'preview')
            setTimeout(() => {
                setAnimateAttachments('S_TO_NEXT');
                setRequestSection('attachment');
            }, 300);
    };

    const getModalAddCustomerData = (data: SearchResultDocument) => {;
        // let customerData: IAddCustomerData = {};
        // customerData.applicationId = data.backendId;
        // customerData.unifiedTrackingId = data.unifiedTrackingId;
        setRequestId(data.unifiedTrackingId);
        refetchRequestDetails();
        // customerData.requestType = data.requestType;
        // customerData.requestTeam = data.requestTeam;
        // customerData.summary = data.title;
        // customerData.customerImpacts = data.customerImpacts;
        let customerData = new RequestDto();
        customerData.init({
            applicationId: data.backendId,
            unifiedTrackingId: data.unifiedTrackingId,
            requestType: data.requestType,
            requestTeam: data.requestTeam,
            summary: data.title,
            customerImpacts: data.customerImpacts
        })
        setAddCusModal(customerData);
    };

    interface IDraft {
            version: number,
            
            // RequestDto
            requestType: string;
            searchValue: string;
            requestDesc: string;
            msxMatched: boolean;
            filteredData: MsxSuggestDocument[];
            dateImportance: string;
            dateImportanceToSubmit: string;
            dateSent: string;
            impDevices: string;
            revenueRisk: string;
            selectedProductName: string;
            emailID: string;
            shippingAdd: string;
            mobileNumber: string;
            custEmail: string;
            contactNum: string;
            custShippingAddress: string;
            cssCaseNum: string;
            fundsDescription: string;
            selectedDCFKey: string;
            manualData: boolean;
            status: string;
            custName: string;
            tpid: string;
            accountID: string;
            customerImpactDescription: string;
            country: string;
            selectedIssue: IDropdownOption;
            contactName: string;
            newDeviceRisk: string;
            newRevenueRisk: string;
            mobilePrefix: string;
            contactNumPrefix: string | number;

            // Animations & Location
            currentSection: string;
            shrinkAnimation: boolean;
            animateTitle: string;
            animateDescription: string;
            animateAction: string;
            animateDCFAction: string;
            animateCustomer: string;
            animateNewCustomer: string;
            animateAddress: string;
            pageLoadAnimation: boolean;

            // Selected
            selectedModel: DeviceModelDto[];
            selectedProductId: number;
            selectedDate: Date;
            customerSearchInput: string;
            customerSelected: boolean;
            modelsList: DeviceModelDto[];
            cartState: boolean;
            
            // Attached Items
            attachedFiles: Object[];
            attachmentList: IAttachment[];

            // Other
            requestTypeFlow: string; // was any
            requestOptions: EnumLookUp[];
            requestSection: string;
            newRequest: boolean;
            msxOpportunityId: string;
            custAltPage: boolean;
            errorMsg: boolean;
            successMsg: boolean;
            msxData: MsxStaticData[];
            requestStartTime: string;
    }

    const getDraftData = () => {
        let draftData : IDraft = {
            version: 2,
            // Request Dto
            requestType: requestType,
            searchValue: searchValue,
            requestDesc: encodeURIComponent(requestDescriptionToSubmit.length > 0 ? requestDescriptionToSubmit : requestDesc),
            msxMatched: msxMatched,
            filteredData: filteredData,
            dateImportance: encodeURIComponent(dateImportance),
            dateImportanceToSubmit: encodeURIComponent(dateImportanceToSubmit),
            dateSent: dateSent,
            impDevices: impDevices,
            revenueRisk: revenueRisk,
            selectedProductName: selectedProductName,
            emailID: emailID,
            shippingAdd: shippingAdd,
            mobileNumber: mobileNumber,
            custEmail: customerEmail,
            contactNum: contactNum,
            custShippingAddress: customerShippingAddress,
            cssCaseNum: cssCaseNum,
            fundsDescription: fundsDescription,
            selectedDCFKey: selectedDCFKey,
            manualData: manualData,
            requestStartTime: requestStartTime.current.toString(),

            custName: customerName,
            status: msxStatus,
            tpid: customerTPID,
            accountID: customerAccountID,
            customerImpactDescription: customerImpactDescription,
            country: country,
            selectedIssue: selectedIssue,
            contactName: contactName,
            newDeviceRisk: newDeviceRisk,
            newRevenueRisk: newRevenueRisk,
            mobilePrefix: mobilePrefix,
            contactNumPrefix: contactNumPrefix,
            
            // Animations & Location
            currentSection: currentSection,
            shrinkAnimation: shrinkAnimation,
            animateTitle: animateTitle,
            animateDescription: animateDescription,
            animateAction: animateAction,
            animateDCFAction: animateDCFAction,
            animateCustomer: animateCustomer,
            animateNewCustomer: animateNewCustomer,
            animateAddress: animateAddress,
            pageLoadAnimation: pageLoadAnimation,

            // Selected
            selectedModel: selectedModel,
            selectedProductId: selectedProductId,
            selectedDate: selectedDate,
            customerSearchInput: customerSearchInput,
            customerSelected: customerSelected,
            modelsList: modelsList,
            cartState: cartState,

            // Attached Items
            attachedFiles: attachedFiles,
            attachmentList: attachmentList,

            // Other
            requestTypeFlow: requestTypeFlow,
            requestOptions: requestOptions,
            requestSection: requestSection,
            newRequest: newRequest,
            msxOpportunityId: msxOpportunityId,
            custAltPage: customerAltPage,
            errorMsg: errorMsg,
            successMsg: successMsg,
            msxData: msxData
        };
        return draftData;
    };
    
    const submitDraftData = () => {
        draftSaveRequest(JSON.stringify(getDraftData()));
    };

    const setDraftData = (data: string) => {
        let parsedData: IDraft;
        try {
            const result: unknown = JSON.parse(data);
            // JSON.parse can legitimately return null or a primitive (e.g. cached "null"). Treat
            // anything that isn't a real object as a non-restorable draft so we don't crash below.
            if (typeof result !== 'object' || result === null) {
                appInsightsService.logEvent('DraftRequestParseFailed', { error: 'Parsed draft is not an object' });
                return;
            }
            parsedData = result as IDraft;
        } catch (e) {
            // Corrupt legacy draft (e.g. an inch-quote device name mis-escaped by the old save
            // path) can't be recovered. Skip restore so the landing screen renders instead of
            // crashing blank. Cache is left intact; the user's next save overwrites it cleanly.
            appInsightsService.logEvent('DraftRequestParseFailed', { error: String(e) });
            return;
        }
        if (parsedData && parsedData?.version !== 2) {
            return;
        }
        // Request Dto
        setRequestType(parsedData.requestType);
        setSearchValue(parsedData.searchValue);
        setRequestDesc(decodeURIComponent(parsedData.requestDesc));
        setRequestDescriptionToSubmit(decodeURIComponent(parsedData.requestDesc));
        setMSXMatched(parsedData.msxMatched);
        setFilteredData(parsedData.filteredData);
        setDateImportance(decodeURIComponent(parsedData.dateImportance));
        setDateImportanceToSubmit(decodeURIComponent(parsedData.dateImportanceToSubmit));
        setDateSent(parsedData.dateSent);
        setImpDevices(parsedData.impDevices);
        setRevenueRisk(parsedData.revenueRisk);
        setSelectedProductName(parsedData.selectedProductName);
        setEmailID(parsedData.emailID);
        setShippingAdd(parsedData.shippingAdd);
        setMobileNumber(parsedData.mobileNumber);
        setCustomerEmail(parsedData.custEmail);
        setContactNum(parsedData.contactNum);
        setCustomerShippingAddress(parsedData.custShippingAddress);
        setCSSCaseNum(parsedData.cssCaseNum);
        setFundDescription(parsedData.fundsDescription);
        setSelectedDCFKey(parsedData.selectedDCFKey);
        setManualData(parsedData.manualData);
        setMsxStatus(parsedData.status);
        setCustomerName(parsedData.custName);
        setCustomerTPID(parsedData.tpid);
        setCustomerAccountID(parsedData.accountID);
        setCustomerImpactDescription(parsedData.customerImpactDescription);
        setCountry(parsedData.country);
        setSelectedIssue(parsedData.selectedIssue);
        setContactName(parsedData.contactName);
        setNewDeviceRisk(parsedData.newDeviceRisk);
        setNewRevenueRisk(parsedData.newRevenueRisk);
        setMobilePrefix(parsedData.mobilePrefix);
        setContactNumPrefix(parsedData.contactNumPrefix);
        
        // Animations & Location
        setCurrentSection(parsedData.currentSection);
        setShrinkAnimation(parsedData.shrinkAnimation);
        setAnimateTitle(parsedData.animateTitle);
        setAnimateDescription(parsedData.animateDescription);
        setAnimateAction(parsedData.animateAction);
        setAnimateDCFAction(parsedData.animateDCFAction);
        setAnimateCustomer(parsedData.animateCustomer);
        setAnimateNewCustomer(parsedData.animateNewCustomer);
        setAnimateAddress(parsedData.animateAddress);
        setPageLoadAnimation(parsedData.pageLoadAnimation);

        // Selected
        setSelectedModel(parsedData.selectedModel);
        setSelectedProductId(parsedData.selectedProductId);
        setSelectedDate(new Date(parsedData.selectedDate));
        setCustomerSearchInput(parsedData.customerSearchInput);
        setCustomerSelected(parsedData.customerSelected);
        setModelsList(parsedData.modelsList);
        setCartState(parsedData.cartState);

        // Attached Items
        addFiles(parsedData.attachedFiles);
        setAttachmentList(parsedData.attachmentList);


        // Other
        setRequestTypeFlow(parsedData.requestTypeFlow);
        setRequestOptions(parsedData.requestOptions);
        setRequestSection(parsedData.requestSection);
        setNewRequest(parsedData.newRequest);
        setMsxOpportunityId(parsedData.msxOpportunityId);
        setCustomerAltPage(parsedData.custAltPage);
        setErrorMsg(parsedData.errorMsg);
        setSuccessMsg(parsedData.successMsg);
        setMsxData(parsedData.msxData);
        requestStartTime.current = new Date(String(parsedData.requestStartTime));
        logRequestflowTelemetry(TelemetryConstants.DRAFT_REQUEST_LOADED);
    };
    const handleClick = (dir: string) => {
        if (dir === 'NEXT') {
            if (currentSection === 'titleSearchField') {
                setShrinkAnimation(false);
                if (searchValue.trim() === '') {
                    setTitleHText(true);
                } else {
                    setAnimateTitle('A_TO_RIGHT');
                    setTimeout(function () {
                        setAnimateDescription('S_TO_PREV');
                        setCurrentSection(StringConstants.DESCRIPTION);
                        setTimeout(() => {
                            document.getElementById('description-field')?.focus();
                        }, 300)
                    }, 300);
                }
                logRequestflowTelemetry(TelemetryConstants.REQUEST_TITLE_ENTERED, { "title_len": String(searchValue.length), "validation_error": String(searchValue.trim() === '') });
            } else if (currentSection === StringConstants.DESCRIPTION) {
                setTempDescriptionValue(
                    requestDescriptionToSubmit.length > 0 ? requestDescriptionToSubmit.concat('') : requestDesc.concat('')
                );
                if (requestDesc.trim() === '' && requestDescriptionToSubmit.trim() === '') {
                    setDescHText(true);
                } else {
                    if (redirectRequestType !== '') {
                        setOriginalRoutingML(false);
                        setTempFlow(quickLinksFLow);
                        setRequestTypeFlow(quickLinksFLow);
                        setRequestType(redirectRequestType);
                        setCurrentSection('reqDetailsPage');
                        setRequestSection('selectDevice');
                        setTimeout(function () {
                            document.getElementById('products-list')?.setAttribute("aria-label", "select the troubled product family");
                        }, 1000)
                    } else {
                        if (!isGettingRequestType) {
                            setOriginalRoutingML(true);
                            getRequestType();
                        }
                    }
                    setFullReverse(false);
                    setAnimateStep('STEP_1');
                    setAnimateStepReverse('');
                }
            }
        } else {
            if (currentSection === 'titleSearchField') {
                setTitleHText(false);
                setCurrentSection('landing');
            } else if (currentSection === StringConstants.DESCRIPTION) {
                setTempDescriptionValue(
                    requestDescriptionToSubmit.length > 0 ? requestDescriptionToSubmit.concat('') : requestDesc.concat('')
                );
                setDescHText(false);
                setShrinkAnimation(false);
                setAnimateDescription('A_TO_LEFT');
                setTimeout(() => {
                    setAnimateTitle('S_TO_NEXT');
                    setCurrentSection('titleSearchField');
                }, 300);
            }
        }
    };

    const nextWizard = () => {
        if (requestSection === 'details') {
        } else if (requestSection === 'selectDevice') {
            if (
                selectedProductId === undefined ||
                selectedModel.length === 0 ||
                fieldValidation("selectedModel", 'modelCount', selectedModel)
            ) {
                setAddProductHText(selectedProductId === undefined);

                if (!(selectedProductId === undefined)) {
                    setAddModelHText(selectedModel.length === 0);
                }
                if (!(selectedProductId === undefined) && !(selectedModel.length === 0)) {
                    setCartHText(fieldValidation("selectedModel", 'modelCount', selectedModel) as boolean);
                }
            } else {
                setTimeout(() => {
                    setCartState(true);
                    setRequestSection('action');
                    setAnimateAction('S_TO_PREV');
                    logRequestflowTelemetry(TelemetryConstants.DEVICES_SELECTED, {
                        'families_count': modelsList.reduce((acc, curr) => acc + (curr.isAdded ? 1 : 0), 0).toString(),
                        'device_count': modelsList.reduce((acc, curr) => acc + curr.count, 0).toString()
                    })
                }, 300);
                setTimeout(() => {
                    document.getElementById('resolution-date-picker')?.focus()
                }, 500)
            }
            setPreviewHText(false);
        } else if (requestSection === 'customer') {
            if (
                !isNumberGreaterThanZero(revenueRisk?.toString().replace('$', '').replaceAll(',', '')) ||
                impDevices.trim() === '' ||
                impDevices.trim() === '0' ||
                (requestType === 'CSSRequest' &&
                    emailID.trim() !== '' &&
                    !fieldValidation(emailID.trim(), 'email', selectedModel))
            ) {
                if (parseInt(impDevices?.replaceAll(',', '')) === filteredData[0]?.totalDeviceCount) {
                    setImpDevices(null);
                }
                if (parseFloat(revenueRisk?.replace('$', '').replaceAll(',', '')) === filteredData[0]?.estimatedValue) {
                    setRevenueRisk(null);
                }
                setAutoSuggestHText(!customerSelected);
                setRevenueHText(!isNumberGreaterThanZero(revenueRisk?.toString().replace('$', '').replaceAll(',', '')));
                setImpDevicesHText(impDevices?.trim() === '' || impDevices?.trim() === '0' ? true : false);
                setEmailValidText(
                    emailID.trim() !== '' && !fieldValidation(emailID.trim(), 'email', selectedModel) ? true : false
                );
            } else {
                setAnimateCustomer('A_TO_RIGHT');
                setTimeout(function () {
                    setAnimateAddress('S_TO_PREV');
                    setRequestSection('address');
                }, 300);
                setTimeout(() => {
                    document.getElementById('customer-name-input')?.focus();
                }, 300);
            }
        } else if (requestSection === 'newCustomer') {
            if (
                customerName?.trim() === '' ||
                country?.trim() === '' ||
                !isNumberGreaterThanZero(newRevenueRisk.toString().replace('$', '').replaceAll(',', '')) ||
                newDeviceRisk.trim() === '' ||
                newDeviceRisk.trim() === '0'
            ) {
                customerInputType === 'search'
                    ? setAutoSuggestHText(customerName?.trim() === '' ? true : false)
                    : setCustomerNameHText(customerName?.trim() === '' ? true : false);
                setCountry(country);
                setRevenueHText(!isNumberGreaterThanZero(newRevenueRisk.toString().replace('$', '').replaceAll(',', '')));
                setImpDevicesHText(newDeviceRisk.trim() === '' || newDeviceRisk.trim() === '0');
            } else {
                setAnimateNewCustomer('A_TO_RIGHT');
                setTimeout(function () {
                    setAnimateAddress('S_TO_PREV');
                    setRequestSection('address');
                }, 300);
            }
        } else if (requestSection === 'address') {
            if (
                !fieldValidation(customerEmail.trim(), 'email', selectedModel) ||
                !fieldValidation(contactNum.trim(), 'mobile number', selectedModel) ||
                customerShippingAddress.trim() === '' ||
                contactName.trim() === ''
            ) {
                setContactNameHText(contactName.trim() === '' ? true : false);
                setCustomerEmailHText(!fieldValidation(customerEmail.trim(), 'email', selectedModel));
                setContactNumHText(!fieldValidation(contactNum.trim(), 'mobile number', selectedModel));
                setCustomerShippingAddHText(customerShippingAddress.trim() === '' ? true : false);
            } else {
                setRequestSection('DCF_ACTION');
            }
        } else if (requestSection === 'REVIEW_CUSTOMER') {
            if (cssCaseNum.trim() === '') {
                setCaseNumHText(true);
            } else {
                setAnimateReviewCustomer('A_TO_RIGHT');
                setTimeout(() => {
                    if (manualData) {
                        setRequestSection('newCustomer');
                    } else {
                        setAnimateCustomer('S_TO_PREV');
                        setRequestSection('customer');
                    }
                }, 300);
            }
        } else if (requestSection === 'action') {
            setTempDateImportanceValue(
                dateImportanceToSubmit.length > 0 ? dateImportance.concat('') : dateImportance?.concat('')
            );
            if (
                (dateImportance.trim() === '' && dateImportanceToSubmit.trim() === '') ||
                (requestType === 'CSSRequest' && selectedIssue === undefined)
            ) {
                setIssueHText(requestType === 'CSSRequest' && selectedIssue === undefined);
                setDateImportanceHText(dateImportance.trim() === '');
            } else {
                setAnimateAction('A_TO_RIGHT');
                setTimeout(() => {
                    setAnimateDCFAction('S_TO_PREV');
                    setRequestSection('DCF_ACTION');
                }, 300);

                setTimeout(() => {
                    document.getElementById('dcf')?.focus()
                }, 500)
            }
        }
    };
    const previousWizard = () => {
        if (requestSection === 'selectDevice') {
            setCartState(false);
            setShrinkAnimation(true);
            setCurrentSection(StringConstants.DESCRIPTION);
        } else if (requestSection === 'customer' || requestSection === 'newCustomer') {
            if (requestSection === 'customer') {
                setAnimateCustomer('A_TO_LEFT');
            }

            setTimeout(function () {
                if (requestType === StringConstants.REVIEW_REQUEST) {
                    setRequestSection('REVIEW_CUSTOMER');
                    setAnimateReviewCustomer('S_TO_NEXT');
                } else {
                    setRequestSection('action');
                }
            }, 300);

            setAnimateCustomer('A_TO_RIGHT');
        } else if (requestSection === 'action') {
            setTempDateImportanceValue(
                dateImportanceToSubmit.length > 0 ? dateImportanceToSubmit.concat('') : dateImportance?.concat('')
            );
            setAnimateAction('A_TO_LEFT');
            setTimeout(function () {
                setCartState(false);
                setRequestSection('selectDevice');
            }, 300);
        } else if (requestSection === 'address') {
            setAnimateAddress('A_TO_LEFT');
            setTimeout(function () {
                if (manualData) {
                    setAnimateNewCustomer('S_TO_NEXT');
                    setRequestSection('newCustomer');
                } else {
                    setAnimateCustomer('S_TO_NEXT');
                    setRequestSection('customer');
                }
            }, 300);
        } else if (requestSection === 'DCF_ACTION') {
            setAnimateDCFAction('A_TO_LEFT');
            setTimeout(function () {
                setAnimateAction('S_TO_NEXT');
                setRequestSection('action');
            }, 300);
        } else if (requestSection === 'REVIEW_CUSTOMER') {
            setAnimateReviewCustomer('A_TO_LEFT');
            setTimeout(function () {
                setRequestSection('details');
            }, 300);
        }
    };

    const keyPress = (event: React.KeyboardEvent<HTMLElement>, handler: Function, dir?: string) => {
        if (event.key === 'Enter') {
            if (dir) {
                handler(dir);
            } else {
                handler();
            }
        }
    };

    function nextBtnEnablingHandler() {
        if (currentSection === 'titleSearchField' && searchValue.trim() !== '') {
            return true;
        } else if (
            currentSection === StringConstants.DESCRIPTION &&
            (requestDesc.trim() !== '' || requestDescriptionToSubmit !== '')
        ) {
            return true;
        } else if (currentSection === 'reqDetailsPage') {
            if (
                requestSection === 'selectDevice' &&
                selectedProductId !== undefined &&
                selectedModel.length !== 0 &&
                !fieldValidation("selectedModel", 'modelCount', selectedModel)
            ) {
                return true;
            } else if (requestSection === 'action' && (dateImportance.trim() !== '' || dateImportanceToSubmit.trim() !== '')) {
                return true;
            } else if (requestSection === 'DCF_ACTION') {
                if (selectedDCFKey === 'B' || (selectedDCFKey === 'A' && fundsDescription.trim() !== '')) {
                    return true;
                }
            } else if (requestSection === 'customer') {
                if (
                    isNumberGreaterThanZero(revenueRisk?.toString().replace('$', '').replaceAll(',', '')) &&
                    impDevices?.trim() !== '' &&
                    impDevices?.trim() !== '0' &&
                    (requestType === StringConstants.REVIEW_REQUEST ? cssCaseNum.trim() !== '' : true)
                ) {
                    return true;
                }
                if (TEAM_DETAILS[0].id === StringConstants.CSS || TEAM_DETAILS[0].id === StringConstants.CXP) {
                    setCaseNumHText(cssCaseNum.trim() !== '');
                }
            } else if (requestSection === 'newCustomer') {
                if (
                    customerName?.trim() !== '' &&
                    country?.trim() !== '' &&
                    isNumberGreaterThanZero(newRevenueRisk.toString().replace('$', '').replaceAll(',', '')) &&
                    newDeviceRisk.trim() !== '' &&
                    newDeviceRisk.trim() !== '0' &&
                    (requestType === StringConstants.REVIEW_REQUEST ? cssCaseNum.trim() !== '' : true)
                ) {
                    return true;
                }
                if (TEAM_DETAILS[0].id === StringConstants.CSS || TEAM_DETAILS[0].id === StringConstants.CXP) {
                    setCaseNumHText(cssCaseNum.trim() !== '');
                }
            } else if (requestSection === 'address') {
                if (
                    fieldValidation(customerEmail.trim(), 'email', selectedModel) &&
                    fieldValidation(contactNum.trim(), 'mobile number', selectedModel) &&
                    customerShippingAddress.trim() !== '' &&
                    contactName.trim() !== '' &&
                    contactNumPrefix
                ) {
                    return true;
                }
            } else if (requestSection === 'preview' && selectedModel.length !== 0) {
                return true;
            } else if (requestSection === 'attachment') {
                return true;
            }
        }
    }

    const getPlaceholderText = () => {
        let example = '';
        if (!quickLinksValue && redirectRequestType === '') {
            example = 'For example: My customer needs more attention on a support case';
        } else if (quickLinksValue === 1) {
            example = 'For example: I need help filling out an RFP for my customer.';
        } else if (redirectRequestType === StringConstants.POST_SALES) {
            example = 'For example: What protection plans are available in my market?';
        } else if (redirectRequestType === StringConstants.REVIEW_REQUEST) {
            example = 'For example: My customer needs more attention on a support case.';
        } else if (redirectRequestType === StringConstants.IRT && quickLinksFLow === 9) {
            example = 'For example: Can we make an ARM based Surface Go?';
        } else if (redirectRequestType === StringConstants.IRT && quickLinksFLow === 10) {
            example = 'For example: Which Surface devices will run Windows 11?';
        }
        return example ? `${example}${SEARCH_PLACEHOLDERS.ticketCreationHint}` : '';
    };
    function previousBtnEnablingHandler() {
        if (currentSection === 'titleSearchField' && searchValue.trim() === '') {
            return true;
        } else if (
            currentSection === StringConstants.DESCRIPTION &&
            (requestDesc.trim() === '' || requestDescriptionToSubmit === '')
        ) {
            return true;
        } else if (currentSection === 'reqDetailsPage') {
            if (
                requestSection === 'selectDevice' &&
                (selectedProductId === undefined ||
                    selectedModel.length === 0 ||
                    fieldValidation("selectedModel", 'modelCount', selectedModel))
            ) {
                return true;
            } else if (
                requestSection === 'action' &&
                (dateImportance || dateImportanceToSubmit) &&
                (dateImportance.trim() === '' || dateImportanceToSubmit === '')
            ) {
                return true;
            } else if (requestSection === 'DCF_ACTION') {
                if (
                    (selectedDCFKey === 'A' && fundsDescription.trim() === '') ||
                    (selectedDCFKey !== 'B' && selectedDCFKey !== 'A')
                ) {
                    return true;
                }
            } else if (requestSection === 'address') {
                if (
                    !fieldValidation(customerEmail.trim(), 'email', selectedModel) ||
                    !fieldValidation(contactNum.trim(), 'mobile number', selectedModel) ||
                    customerShippingAddress.trim() === '' ||
                    contactName.trim() === ''
                ) {
                    return true;
                }
            }
        }
    }

    function onBackLink() {
        if (requestSection === 'customer') {
            setAnimateCustomer('A_TO_LEFT');
            setTimeout(function () {
                if (requestType === StringConstants.POST_SALES) {
                    setAnimateDCFAction('S_TO_NEXT');
                    setRequestSection('DCF_ACTION');
                } else {
                    setAnimateAction('S_TO_NEXT');
                    setRequestSection('action');
                }
            }, 300);
        }
        if (requestSection === 'newCustomer') {
            setManualData(false);
            setRequestSection('customer');
            setRevenueHText(false);
            setImpDevicesHText(false);
            setImpactsHText(false);
        }
        if (requestSection === 'attachment') {
            setAnimateAttachments('A_TO_LEFT');
            if (customerInputType === 'search') {
                setToggleSearch(false);
            } else {
                setToggleSearch(true);
            }
            setTimeout(() => {
                if (requestType === StringConstants.POST_SALES) {
                    setAnimateAddress('S_TO_NEXT');
                    setRequestSection('address');
                } else {
                    if (manualData) {
                        setAnimateNewCustomer('S_TO_NEXT');
                        setRequestSection('newCustomer');
                    } else {
                        setAnimateCustomer('S_TO_NEXT');
                        setRequestSection('customer');
                    }
                }
            }, 300);
        }
        if (requestSection === 'preview') {
            setTimeout(() => {
                setRequestSection('attachment');
            }, 300);
            setAnimateAttachments('S_TO_NEXT');
            setAnimatePreview('A_TO_RIGHT');
            setAnimateStep('STEP_4');
            setAnimateStepReverse('STEP_4');
            setCartState(false);
        }
    }

    const getIconSvg = (iconName: string) => {
        switch (iconName) {
            case 'requestDetails':
                return (
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.49942 16.5006C8.32752 16.5006 8.99883 17.1719 8.99883 18C8.99883 18.8281 8.32752 19.4994 7.49942 19.4994C6.67131 19.4994 6 18.8281 6 18C6 17.1719 6.67131 16.5006 7.49942 16.5006ZM11.5003 17H21.0035C21.5558 17 22.0035 17.4477 22.0035 18C22.0035 18.5128 21.6174 18.9355 21.1201 18.9933L21.0035 19H11.5003C10.9481 19 10.5003 18.5523 10.5003 18C10.5003 17.4872 10.8864 17.0645 11.3837 17.0067L11.5003 17H21.0035H11.5003ZM3.49942 10.5006C4.32752 10.5006 4.99883 11.1719 4.99883 12C4.99883 12.8281 4.32752 13.4994 3.49942 13.4994C2.67131 13.4994 2 12.8281 2 12C2 11.1719 2.67131 10.5006 3.49942 10.5006ZM7.50034 11H21.0035C21.5558 11 22.0035 11.4477 22.0035 12C22.0035 12.5128 21.6174 12.9355 21.1201 12.9933L21.0035 13H7.50034C6.94805 13 6.50034 12.5523 6.50034 12C6.50034 11.4872 6.88638 11.0645 7.38372 11.0067L7.50034 11H21.0035H7.50034ZM3.49942 4.50781C4.32752 4.50781 4.99883 5.17912 4.99883 6.00723C4.99883 6.83533 4.32752 7.50664 3.49942 7.50664C2.67131 7.50664 2 6.83533 2 6.00723C2 5.17912 2.67131 4.50781 3.49942 4.50781ZM7.50034 5.00082H21.0035C21.5558 5.00082 22.0035 5.44854 22.0035 6.00082C22.0035 6.51366 21.6174 6.93633 21.1201 6.9941L21.0035 7.00082H7.50034C6.94805 7.00082 6.50034 6.55311 6.50034 6.00082C6.50034 5.48799 6.88638 5.06532 7.38372 5.00755L7.50034 5.00082H21.0035H7.50034Z" />
                    </svg>
                )
            case 'customerOpportunity':
                return (
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.7545 14.0002C18.9966 14.0002 20.0034 15.007 20.0034 16.2491V16.8245C20.0034 17.7188 19.6838 18.5836 19.1023 19.263C17.5329 21.0965 15.1457 22.0013 12.0004 22.0013C8.8545 22.0013 6.46849 21.0962 4.90219 19.2619C4.32242 18.583 4.00391 17.7195 4.00391 16.8267V16.2491C4.00391 15.007 5.01076 14.0002 6.25278 14.0002H17.7545ZM17.7545 15.5002H6.25278C5.83919 15.5002 5.50391 15.8355 5.50391 16.2491V16.8267C5.50391 17.3624 5.69502 17.8805 6.04287 18.2878C7.29618 19.7555 9.26206 20.5013 12.0004 20.5013C14.7387 20.5013 16.7063 19.7555 17.9627 18.2876C18.3117 17.8799 18.5034 17.361 18.5034 16.8245V16.2491C18.5034 15.8355 18.1681 15.5002 17.7545 15.5002ZM12.0004 2.00488C14.7618 2.00488 17.0004 4.24346 17.0004 7.00488C17.0004 9.76631 14.7618 12.0049 12.0004 12.0049C9.23894 12.0049 7.00036 9.76631 7.00036 7.00488C7.00036 4.24346 9.23894 2.00488 12.0004 2.00488ZM12.0004 3.50488C10.0674 3.50488 8.50036 5.07189 8.50036 7.00488C8.50036 8.93788 10.0674 10.5049 12.0004 10.5049C13.9334 10.5049 15.5004 8.93788 15.5004 7.00488C15.5004 5.07189 13.9334 3.50488 12.0004 3.50488Z" />
                    </svg>
                )
            case 'attachments':
                return (
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.7722 3.74407C14.1136 1.40049 17.9126 1.40049 20.2558 3.74363C22.5388 6.0267 22.5974 9.69191 20.4314 12.0458L20.2432 12.2432L11.4432 21.0414L11.4066 21.0717C9.94541 22.3884 7.69141 22.3437 6.28404 20.9363C4.96502 19.6173 4.8429 17.5546 5.91769 16.0979C5.94103 16.0525 5.96928 16.0088 6.00249 15.9677L6.05605 15.908L6.14295 15.8203L6.28404 15.6724L6.28695 15.6753L13.7227 8.22096C13.9886 7.95434 14.4052 7.92958 14.6991 8.14704L14.7834 8.21955C15.05 8.48546 15.0747 8.90209 14.8573 9.19599L14.7848 9.28021L7.19015 16.8933C6.47251 17.7689 6.52239 19.0632 7.33979 19.8806C8.16885 20.7096 9.4885 20.7491 10.3643 19.999L19.197 11.1685C20.9525 9.41089 20.9525 6.56165 19.1951 4.80429C17.4927 3.10185 14.7655 3.04865 12.999 4.64469L12.8312 4.80429L12.8186 4.8186L3.28228 14.3549C2.98939 14.6478 2.51452 14.6478 2.22162 14.3549C1.95536 14.0887 1.93115 13.672 2.149 13.3784L2.22162 13.2943L11.7705 3.74363L11.7722 3.74407Z" />
                    </svg>
                )
            case 'preview':
                return (
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.52393 6.25C4.52393 5.83579 4.85971 5.5 5.27393 5.5H18.7297C19.1439 5.5 19.4797 5.83579 19.4797 6.25V9.75C19.4797 10.1642 19.1439 10.5 18.7297 10.5H5.27393C4.85971 10.5 4.52393 10.1642 4.52393 9.75V6.25ZM6.02393 7V9H17.9797V7H6.02393ZM14.2297 11.979C13.8155 11.979 13.4797 12.3148 13.4797 12.729V17.229C13.4797 17.6432 13.8155 17.979 14.2297 17.979H18.7297C19.1439 17.979 19.4797 17.6432 19.4797 17.229V12.729C19.4797 12.3148 19.1439 11.979 18.7297 11.979H14.2297ZM14.9797 16.479V13.479H17.9797V16.479H14.9797ZM4.52393 13.25C4.52393 12.8358 4.85971 12.5 5.27393 12.5H11.25C11.6642 12.5 12 12.8358 12 13.25C12 13.6642 11.6642 14 11.25 14H5.27393C4.85971 14 4.52393 13.6642 4.52393 13.25ZM5.27393 16C4.85971 16 4.52393 16.3358 4.52393 16.75C4.52393 17.1642 4.85971 17.5 5.27393 17.5H11.25C11.6642 17.5 12 17.1642 12 16.75C12 16.3358 11.6642 16 11.25 16H5.27393ZM2 5.75C2 4.23122 3.23122 3 4.75 3H19.25C20.7688 3 22 4.23122 22 5.75V18.25C22 19.7688 20.7688 21 19.25 21H4.75C3.23122 21 2 19.7688 2 18.25V5.75ZM4.75 4.5C4.05964 4.5 3.5 5.05964 3.5 5.75V18.25C3.5 18.9404 4.05964 19.5 4.75 19.5H19.25C19.9404 19.5 20.5 18.9404 20.5 18.25V5.75C20.5 5.05964 19.9404 4.5 19.25 4.5H4.75Z" />
                    </svg>
                )
            case 'selectDevice':
                return (
                    <svg className={`device-icon ${requestSection === 'selectDevice' ? 'active-icon' : ''}`} viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6.25C4 5.00736 5.00736 4 6.25 4H17.75C18.9926 4 20 5.00736 20 6.25V13.75C20 14.9926 18.9926 16 17.75 16H6.25C5.00736 16 4 14.9926 4 13.75V6.25ZM2.75 17.5C2.33579 17.5 2 17.8358 2 18.25C2 18.6642 2.33579 19 2.75 19H21.25C21.6642 19 22 18.6642 22 18.25C22 17.8358 21.6642 17.5 21.25 17.5H2.75Z" />
                    </svg>
                )
            case 'action':
                return (
                    <svg className={`action-icon ${requestSection === 'action' || requestSection === 'DCF_ACTION' ? 'active-icon' : ''}`} viewBox="0.5 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm2.61-4a2.61 2.61 0 1 1-5.22 0 2.61 2.61 0 0 1 5.22 0zM8 5.246z" />
                    </svg>
                )
            default:
                break;
        }
    }

    const iconGenerator = (iconName: string, completed: boolean) => {
        if (completed) {
            return (
                <svg className='completed-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">
                    <path d="M1570 437q42 0 78 15t64 43 42 63 16 79q0 40-15 77t-43 65l-794 795q-28 28-65 43t-77 16q-40 0-77-15t-65-44l-362-362q-28-28-43-65t-16-77q0-42 16-78t43-64 63-42 79-16q40 0 77 15t65 43l220 220 652-653q28-28 65-43t77-15z" />
                </svg>
            )
        }

        return getIconSvg(iconName);
    }

    class ExpandableSearchResultDocumentResponse extends SearchResultDocumentResponse {
        expanded? : boolean | undefined
    }

    function logRequestflowTelemetry(action: string, properties: { [key: string]: string } = {}) {
        properties['requestSection'] = requestSection;
        appInsightsService.logRequestflowTelemetry(action, currentSection, properties);
    }

    if (isLoading) {
        return <Loader classNames="height-70" />;
    } else
        return (
            <div className={`req-exp-cont ${currentSection !== 'landing' ? 'hide-overflow' : ''}`}>
                <NavigationPrompt
                    when={(currentLocation, nextLocation, _action) => {
                        if (nextLocation?.pathname?.includes('unified-dashboard') && _action === 'PUSH') {
                            return false;
                        } else if (nextLocation?.pathname?.includes('knowledge-portal') && isCancelCLicked === true) {
                            return false;
                        } else if (nextLocation?.pathname?.startsWith(currentLocation?.pathname)) {
                            return false;
                        } else {
                            if (currentSection !== 'landing' && !errorMsg && !successMsg) {
                                if (!hideDialog) {
                                    toggleHideDialog();
                                }
                                if (!hideCancelConfirmationDialog) {
                                    toggleCancelConfirmationDialog();
                                }
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }}
                    disableNative={true}>
                    {({ onConfirm, onCancel }: ChildData) => <PromptModal when={true} onOK={onConfirm} onCancel={onCancel} />}
                </NavigationPrompt>
                {
                    <ScreenBg
                        step={` ${animateStep.includes('STEP_1') ? 'step1' : ''}
                                ${animateStep.includes('STEP_2') ? 'step2' : ''}
                                ${animateStep.includes('STEP_3') ? 'step3' : ''}
                                ${animateStep.includes('STEP_4') ? 'step4' : ''}
                                ${animateStepReverse.includes('STEP_1') ? 'step1-rev' : ''}
                                ${animateStepReverse.includes('STEP_2') ? 'step2-rev' : ''}
                                ${animateStepReverse.includes('STEP_3') ? 'step3-rev' : ''}
                                ${animateStepReverse.includes('STEP_4') ? 'step4-rev' : ''}
                                ${fullReverse ? 'step4-to-step0' : ''}`}
                    />
                }
                <ReqExpBanner />
                <div aria-label="Exiting List" tabIndex={0} className="content-cont container">
                    <div className={`landing-screen-cont ${currentSection === 'reqDetailsPage' ? 'no-margin' : ''}`}>
                        {(quickLinksValue || redirectRequestType !== '') && (
                            <div
                                aria-label="monitor icon"
                                tabIndex={0}
                                className={`quicklinks-tag ${currentSection === 'reqDetailsPage' ? 'no-bg' : ''}`}>
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.25 4C5.00736 4 4 5.00736 4 6.25V13.75C4 14.9926 5.00736 16 6.25 16H17.75C18.9926 16 20 14.9926 20 13.75V6.25C20 5.00736 18.9926 4 17.75 4H6.25ZM5.5 6.25C5.5 5.83579 5.83579 5.5 6.25 5.5H17.75C18.1642 5.5 18.5 5.83579 18.5 6.25V13.75C18.5 14.1642 18.1642 14.5 17.75 14.5H6.25C5.83579 14.5 5.5 14.1642 5.5 13.75V6.25ZM2.75 17.5C2.33579 17.5 2 17.8358 2 18.25C2 18.6642 2.33579 19 2.75 19H21.25C21.6642 19 22 18.6642 22 18.25C22 17.8358 21.6642 17.5 21.25 17.5H2.75Z" />
                                </svg>
                                <Text>{getQuickLinksText(quickLinksValue, redirectRequestType, quickLinksFLow)}</Text>
                            </div>
                        )}
                        <div className={`title-container ${shrinkAnimation ? 'shrink' : ''}`}>
                            {(currentSection === 'titleSearchField' || currentSection === StringConstants.DESCRIPTION) && (
                                <div className={`title-header `}>
                                    <Text className="new-request-text" aria-label="Creating a new request" tabIndex={0}>
                                        Creating a new request
                                    </Text>
                                    <div
                                        onClick={() => {
                                            toggleCancelConfirmationDialog();
                                            logRequestflowTelemetry(TelemetryConstants.CANCEL_REQUEST_CLICKED);
                                        }}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                toggleCancelConfirmationDialog();
                                                logRequestflowTelemetry(TelemetryConstants.CANCEL_REQUEST_CLICKED);
                                            }
                                        }}
                                        tabIndex={0}>
                                        Cancel request
                                    </div>
                                </div>
                            )}

                            {(currentSection === 'landing' ||
                                currentSection === 'titleSearchField' ||
                                currentSection === StringConstants.DESCRIPTION) && (
                                    <div className={`landing-screen ${currentSection === 'landing' ? 'add-radius' : ''}`}>
                                    {currentSection === 'landing' && (
                                        <div
                                            tabIndex={0}
                                            aria-label="Welcome"
                                            className={`welcome-page ${hideSearch ? 'fadeOut' : ''} ${pageLoadAnimation ? 'page-load-animation' : '' }`}>
                                                <div className="welcome-text">
                                                    <Text className="head" tabIndex={0} aria-label={userDetails}>
                                                        <Trans>Hi</Trans> {userDetails},
                                                    </Text>
                                                    <Text className="text" tabIndex={0} aria-label="How can we help you?">
                                                        <Trans>How can we help you?</Trans>
                                                    </Text>
                                                </div>
                                                <div
                                                    className={`search-cont  ${showSuggestion ? 'suggest' : ''} ${searchValue.trim() !== '' && showSuggestion ? 'remove-glow' : ''
                                                        }`}
                                                    ref={searchContainer}>
                                                    <span className={`type-ahead ${showSuggestion ? 'no-border' : ''}`}>
                                                        <Icon iconName="Search" aria-label="Search" tabIndex={0} />
                                                        <TextField
                                                            autoFocus
                                                            ariaLabel={'help-description text input'}
                                                            autoComplete={'off'}
                                                            componentRef={searchFieldRef}
                                                            value={searchValue}
                                                            onChange={prepareSearch}
                                                            onFocus={handleFocus}
                                                            onBlur={handleBlur}
                                                            placeholder={showPrompt ? '' : getPlaceholderText()}
                                                            data-testid="showprompt-placeholder"
                                                        />
                                                        {isRecording && (
                                                            <div
                                                                className="recording-row recording-position"
                                                                onClick={() => voiceSearchOff()}>
                                                                <div className="first-line"></div>
                                                                <div className="second-line"></div>
                                                                <div className="third-line"></div>
                                                                <div className="fourth-line"></div>
                                                                <div className="fifth-line"></div>
                                                            </div>
                                                        )}
                                                        {!isRecording && (
                                                            <i
                                                                className="micro-icon"
                                                                onKeyPress={(e: React.KeyboardEvent<HTMLElement>) => keyPress(e, () => voiceSearchOn())}
                                                                tabIndex={0}
                                                                onClick={() => voiceSearchOn()}
                                                                aria-label="voice-icon"
                                                                role="button"></i>
                                                        )}
                                                    </span>
                                                    {showSuggestion && (
                                                        <div className={`suggestion`}>
                                                            {showPrompt && (
                                                                <span className={`start`}>
                                                                    <Text
                                                                        className="start-prompt"
                                                                        aria-label={getPlaceholderText()}
                                                                        tabIndex={0}>
                                                                        <Trans>{getPlaceholderText()}</Trans>
                                                                    </Text>
                                                                    <Icon
                                                                        iconName="Cancel"
                                                                        tabIndex={0}
                                                                        ariaLabel="Close Button"
                                                                        onKeyPress={(e: React.KeyboardEvent<HTMLElement>) => keyPress(e, suggestionCancel)}
                                                                        onClick={suggestionCancel}
                                                                    />
                                                                </span>
                                                            )}

                                                            {suggest && (
                                                                <div className={`search-suggestion `}>
                                                                    {suggestResult && suggestResult?.length > 0 && (
                                                                        <Text className="rel-requests" tabIndex={0}>
                                                                            <Trans>Suggested Requests</Trans>
                                                                        </Text>
                                                                    )}
                                                                    {suggestResult &&
                                                                        suggestResult.map((item: ExpandableSearchResultDocumentResponse, idx: number) => {
                                                                            return (
                                                                                <div
                                                                                    key={idx}
                                                                                    className={`suggestion-result-cont ${item.expanded ? 'expanded-result-cont' : ''
                                                                                        }`}
                                                                                    tabIndex={0}
                                                                                    onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                                                                                        keyPress(e, () => {
                                                                                            setExpandVar(
                                                                                                item.document.unifiedTrackingId,
                                                                                                item.expanded
                                                                                            );
                                                                                            if (item.expanded) {
                                                                                                logRequestflowTelemetry(TelemetryConstants.SEARCH_RESULT_CLICKED, {
                                                                                                    searchResultId: item.document?.unifiedTrackingId,
                                                                                                    index: idx?.toString()
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    }
                                                                                    onClick={() =>{
                                                                                        setExpandVar(
                                                                                            item.document.unifiedTrackingId,
                                                                                            item.expanded
                                                                                        )
                                                                                        if (item.expanded) {
                                                                                            logRequestflowTelemetry(TelemetryConstants.SEARCH_RESULT_CLICKED, {
                                                                                                searchResultId: item.document?.unifiedTrackingId,
                                                                                                index: idx?.toString()
                                                                                            });
                                                                                        }
                                                                                    }
                                                                                    }>
                                                                                    <div className="suggestion-result">
                                                                                        {!item.expanded && (
                                                                                            <Image
                                                                                                className="m-r-15"
                                                                                                src={ExpandIcon}
                                                                                                alt="open"
                                                                                            />
                                                                                        )}
                                                                                        {item.expanded && (
                                                                                            <Image
                                                                                                className="m-r-15"
                                                                                                src={CollapseIcon}
                                                                                                alt="close"
                                                                                            />
                                                                                        )}
                                                                                        <Text className="result-skip-id">
                                                                                            {' '}
                                                                                            {item.document.unifiedTrackingId}
                                                                                        </Text>
                                                                                        <span className="dash m-l-10 m-r-10">-</span>{' '}
                                                                                        <span className="result-title">
                                                                                            {item.document.title}
                                                                                        </span>
                                                                                    </div>
                                                                                    {item.expanded && (
                                                                                        <div className="expanded-result">
                                                                                            <Text className="expanded-head">
                                                                                                <Trans>Description</Trans>
                                                                                            </Text>
                                                                                            <Text className="expanded-body">
                                                                                                <span
                                                                                                    dangerouslySetInnerHTML={{
                                                                                                        __html: DOMPurify.sanitize(item.document.description.replace(
                                                                                                            /(<([^>]+)>)/gi,
                                                                                                            ''
                                                                                                        ))
                                                                                                    }}></span>
                                                                                            </Text>
                                                                                            {item.document.requestedResolutionDate && (
                                                                                                <>
                                                                                                    <Text className="expanded-head">
                                                                                                        <Trans>
                                                                                                            Requested resolution date
                                                                                                        </Trans>
                                                                                                    </Text>
                                                                                                    <Text className="expanded-body">
                                                                                                        {item.document.requestedResolutionDate.toDateString()}
                                                                                                    </Text>
                                                                                                </>
                                                                                            )}
                                                                                            <div className="addCustomer-container">
                                                                                                <DefaultButton
                                                                                                    className="default add-cust-btn"
                                                                                                    onClick={() => {
                                                                                                        getModalAddCustomerData(
                                                                                                            item.document
                                                                                                        );
                                                                                                        addSuccessPopUp(false);
                                                                                                        showModalCus();
                                                                                                        appInsightsService.logEvent("SearchResultClick-AddCustomer: clicked a search result to add customer", {
                                                                                                            searchResultId: item.document?.unifiedTrackingId,
                                                                                                            index: idx?.toString()
                                                                                                        });
                                                                                                    }}>
                                                                                                    <Text>
                                                                                                        <Trans>Add a customer</Trans>
                                                                                                    </Text>
                                                                                                </DefaultButton>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    {hideModal && (
                                                                        <Modal
                                                                            titleAriaId={titleId}
                                                                            isOpen={isModalOpenCus}
                                                                            onDismiss={hideModalCus}
                                                                            isBlocking={false}
                                                                            className="add-impact-model">
                                                                            <AddImpact
                                                                                selectedRequest={addCusModal}
                                                                                onDismiss={hideModalCus}
                                                                                globalSelectedRequest={selectedRequest}
                                                                                setSelectedRequest={setSelectedRequest}
                                                                                requestProcessing={requestProcessing}
                                                                                setRequestProcessing={setRequestProcessing}
                                                                                displayScreen={displayScreen}
                                                                                setDisplayScreen={setDisplayScreen}
                                                                            />
                                                                        </Modal>
                                                                    )}
                                                                    <div className="flex-center">
                                                                        <div className="create-req-cont ">
                                                                            <div
                                                                                className="create-req-link"
                                                                                aria-label="Create new request">
                                                                                <Trans>Do you want to</Trans>{' '}
                                                                                <Link
                                                                                    onClick={() => {
                                                                                        setTimeout(function () {
                                                                                            setShrinkAnimation(true);
                                                                                            setNewRequest(true);
                                                                                            setCurrentSection('titleSearchField');
                                                                                            requestStartTime.current = new Date(Date.now());
                                                                                            window.scrollTo({
                                                                                                top: 0,
                                                                                                left: 0,
                                                                                                behavior: 'smooth'
                                                                                            });
                                                                                            document.getElementById('request-title')?.focus()
                                                                                        }, 1000);
                                                                                    logRequestflowTelemetry(TelemetryConstants.INITIATE_NEW_REQUEST);
                                                                                    }}
                                                                                    aria-label="Creating a new request"
                                                                                    tabIndex={0}
                                                                                    data-testid="createnew-test">
                                                                                    <Trans>create a new request?</Trans>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>{' '}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div
                                            className={`first-titlefield-cont ${currentSection === 'titleSearchField' ||
                                                currentSection === StringConstants.DESCRIPTION
                                                ? 'fadeIn add-padding'
                                                : ''
                                                } ${currentSection !== 'titleSearchField' &&
                                                    currentSection !== StringConstants.DESCRIPTION
                                                    ? 'slideUp'
                                                    : ''
                                                }`}>
                                            {(currentSection === 'titleSearchField' ||
                                                currentSection === StringConstants.DESCRIPTION) && (
                                                    <div className="first-titlefield">
                                                        {currentSection === StringConstants.DESCRIPTION && (
                                                            <Label className="desc-label">Please tell us more about your request</Label>
                                                        )}
                                                        <div className="row-flex">
                                                            <div
                                                                tabIndex={0}
                                                                onClick={() => handleClick('BACK')}
                                                                onMouseDown={() => handleClick('BACK')}
                                                                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyPress(e, handleClick, 'BACK')}
                                                                className={`btn  active ${previousBtnEnablingHandler() ? 'button-active-hover' : ''
                                                                    } ${currentSection === StringConstants.DESCRIPTION
                                                                        ? 'align-flex-start'
                                                                        : ''
                                                                    }`}
                                                                aria-label="previous"
                                                                role="button">
                                                                <svg className='left-arrow' viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M12.2197 6.03033C11.9268 5.73744 11.9268 5.26256 12.2197 4.96967C12.5126 4.67678 12.9874 4.67678 13.2803 4.96967L17.7803 9.46967C18.0732 9.76256 18.0732 10.2374 17.7803 10.5303L13.2803 15.0303C12.9874 15.3232 12.5126 15.3232 12.2197 15.0303C11.9268 14.7374 11.9268 14.2626 12.2197 13.9697L16.1893 10L12.2197 6.03033Z" />
                                                                </svg>
                                                            </div>

                                                            {currentSection === 'titleSearchField' && (
                                                                <TextField
                                                                    tabIndex={0}
                                                                    id='request-title'
                                                                    aria-label="This will be the title of your request"
                                                                    label="This will be the title of your request"
                                                                    placeholder="Type your request title here"
                                                                    role='input'
                                                                    value={searchValue}
                                                                    onChange={(e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                                                        setTitleHText(false);
                                                                        setSearchValue((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                                                                    }}
                                                                    onKeyPress={(e: React.KeyboardEvent<HTMLElement>) => keyPress(e, handleClick, 'NEXT')}
                                                                    className={`title-field ${titleHText ? 'error-feild' : ''} ${animateTitle === 'S_TO_NEXT' ? 'nextSlide' : ''
                                                                        } ${animateTitle === 'S_TO_PREV' ? 'prevSlide' : ''} ${animateTitle === 'A_TO_RIGHT' ? 'animateToRIght' : ''
                                                                        } ${animateTitle === 'A_TO_LEFT' ? 'animateToLeft' : ''}`}
                                                                />
                                                            )}
                                                            {currentSection === StringConstants.DESCRIPTION && (
                                                                <div
                                                            id='description-field'
                                                            tabIndex={0}
                                                            aria-label='please tell us more about your request'
                                                            className={`description-field ${animateDescription === 'S_TO_NEXT' ? 'nextSlide' : ''
                                                                } ${animateDescription === 'S_TO_PREV' ? 'prevSlide' : ''} ${animateDescription === 'A_TO_RIGHT' ? 'animateToRIght' : ''
                                                                } ${animateDescription === 'A_TO_LEFT' ? 'animateToLeft' : ''}`}>
                                                                    <CustomField
                                                                        value={requestDescriptionToSubmit}
                                                                        helperText={descHText}
                                                                        setHelperText={setDescHText}
                                                                        tempValue={tempDescriptionValue}
                                                                        type="DESCRIPTION"
                                                                        rows={8}
                                                                        editorState={descEditorState}
                                                                        setEditorState={setDescEditorState}
                                                                        hashTagsFormatted={hashTagsFormatted}
                                                                        setHashTagsFormatted={setHashTagsFormatted}
                                                                        setTextToSubmit={setRequestDescriptionToSubmit}
                                                                    />
                                                                </div>
                                                            )}
                                                            <span
                                                                tabIndex={0}
                                                                onClick={() => handleClick('NEXT')}
                                                                onMouseDown={() => handleClick('NEXT')}
                                                                onKeyPress={(e: React.KeyboardEvent<HTMLSpanElement>) => keyPress(e, handleClick, 'NEXT')}
                                                                className={`btn ${nextBtnEnablingHandler() ? 'active  button-active-hover' : ''
                                                                    } ${currentSection === StringConstants.DESCRIPTION
                                                                        ? 'align-flex-start'
                                                                        : ''
                                                                    } `}
                                                                aria-label="next"
                                                                role="button">
                                                                <svg className='right-arrow' viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M12.2197 6.03033C11.9268 5.73744 11.9268 5.26256 12.2197 4.96967C12.5126 4.67678 12.9874 4.67678 13.2803 4.96967L17.7803 9.46967C18.0732 9.76256 18.0732 10.2374 17.7803 10.5303L13.2803 15.0303C12.9874 15.3232 12.5126 15.3232 12.2197 15.0303C11.9268 14.7374 11.9268 14.2626 12.2197 13.9697L16.1893 10L12.2197 6.03033Z" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                        {titleHText && (
                                                            <Text className={`helper-txt`}>
                                                                <Trans>Please enter a title for your request.</Trans>
                                                            </Text>
                                                        )}
                                                        {descHText && (
                                                            <Text
                                                                className={`helper-txt`}
                                                                tabIndex={0}
                                                                aria-label="Please type in some details for your request so we can help resolve
                                                            your issue faster"
                                                                role="log">
                                                                <Trans>
                                                                    Please type in some details for your request so we can help resolve
                                                                    your issue faster.
                                                                </Trans>
                                                            </Text>
                                                        )}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                    {newRequest && (
                        <div className={`new-req-container ${newRequest ? 'fadeIn' : ''}`}>
                            {currentSection === 'reqDetailsPage' && (
                                <div
                                    className={`new-req-body-container ${requestSection === 'preview' ? 'form-preview' : ''} ${requestSection === 'preview' ? 'preview-bg' : ''
                                        }`}>
                                    <div
                                        className={`title-header remove-bg ${requestSection === 'preview' ? 'change-border' : ''
                                            } `}>
                                        <Text className="new-request-text">Creating a new request</Text>
                                        <div
                                            onClick={() => {
                                                toggleCancelConfirmationDialog();
                                                logRequestflowTelemetry(TelemetryConstants.CANCEL_REQUEST_CLICKED);
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") {
                                                    toggleCancelConfirmationDialog();
                                                    logRequestflowTelemetry(TelemetryConstants.CANCEL_REQUEST_CLICKED);
                                                };
                                            }}
                                            tabIndex={0}
                                            aria-label='cancel request link'
                                            role='button'
                                            className="cancel-request-link">
                                            Cancel request
                                        </div>
                                    </div>
                                    <div className="static-title">
                                        <span className="title-icon"></span>
                                        <Text className="title">
                                            <Trans>Title</Trans> :
                                        </Text>

                                        <Text className="title-value">{searchValue}</Text>
                                    </div>

                                    <div className="progress-bar">
                                        <div
                                            id='active-bar'
                                            className={`active-bar
                                            ${requestSection === 'selectDevice' ||
                                                    requestSection === 'DCF_ACTION' ||
                                                    requestSection === 'action'
                                                    ? 'first-tab'
                                                    : ''
                                                }
                                            ${requestSection === 'customer' ||
                                                    requestSection === 'newCustomer' ||
                                                    requestSection === 'address'
                                                    ? 'second-tab'
                                                    : ''
                                                }
                                            ${requestSection === 'attachment' ? 'third-tab' : ''}
                                            ${requestSection === 'preview' ? 'fourth-tab' : ''}`}>
                                        </div>
                                        <ul className="new-req-body-menu">
                                            <li
                                                className={`${requestSection === 'details' ||
                                                    requestSection === 'selectDevice' ||
                                                    requestSection === 'action' ||
                                                    requestSection === 'DCF_ACTION'
                                                    ? 'active icon-move-up-down'
                                                    : 'complete-section'
                                                    }`}
                                                onClick={selectFirstTab}>
                                                <div className="row-flex-box justify-center" tabIndex={0} aria-label={'request details' + ((requestSection === 'details' || requestSection === 'selectDevice' || requestSection === 'action' || requestSection === 'DCF_ACTION') ? "" : " completed")}>
                                                    <span className="row-flex-box align-center main-tab-item">
                                                        {iconGenerator('requestDetails',
                                                            !(requestSection === 'details' ||
                                                                requestSection === 'selectDevice' ||
                                                                requestSection === 'action' ||
                                                                requestSection === 'DCF_ACTION'))
                                                        }
                                                        <span>
                                                            <Trans>Request Details</Trans>
                                                        </span>
                                                    </span>
                                                </div>
                                            </li>
                                            <li
                                                className={`${requestSection === 'customer' ||
                                                    requestSection === 'newCustomer' ||
                                                    requestSection === 'address'
                                                    ? 'active icon-move-up-down'
                                                    : ''
                                                    } ${requestSection === 'attachment' || requestSection === 'preview'
                                                        ? 'complete-section'
                                                        : ''
                                                    }`}
                                                onClick={selectSecondTab}>
                                                <div className="row-flex-box justify-center" tabIndex={0} aria-label={"customer opportunity" + (!(requestSection === 'attachment' || requestSection === 'preview') ? "" : " completed")}>
                                                    <span className="row-flex-box align-center main-tab-item">
                                                        {iconGenerator('customerOpportunity',
                                                            (requestSection === 'attachment' ||
                                                                requestSection === 'preview'))
                                                        }
                                                        <span>
                                                            <Trans>Customer Opportunity</Trans>
                                                        </span>
                                                    </span>
                                                </div>
                                            </li>
                                            <li
                                                className={`${requestSection === 'attachment' ? 'active icon-move-up-down' : ''}${requestSection === 'preview' ? 'complete-section' : ''
                                                    }`}
                                                onClick={selectThirdTab}>
                                                <div className="row-flex-box justify-center" tabIndex={0} aria-label={"attachments" + (!(requestSection === 'preview') ? "" : " completed")}>
                                                    <span className="row-flex-box align-center main-tab-item">
                                                        {iconGenerator('attachments',
                                                            (requestSection === 'preview'))
                                                        }
                                                        <span>
                                                            <Trans>Attachments</Trans>
                                                        </span>
                                                    </span>
                                                </div>
                                            </li>
                                            <li
                                                className={`${requestSection === 'preview' ? 'active icon-move-up-down' : ''}`}>
                                                <div id='preview' className="row-flex-box justify-center" tabIndex={0} aria-label="preview request">
                                                    <span className="row-flex-box align-center main-tab-item">
                                                        {iconGenerator('preview', false)}
                                                        <span>
                                                            <Trans>Preview</Trans>
                                                        </span>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div
                                        className={`new-req-form-container ${requestSection === 'preview' ? 'form-preview' : ''
                                            }`}>
                                        {requestSection !== 'attachment' &&
                                            requestSection !== 'preview' &&
                                            requestSection !== 'customer' &&
                                            requestSection !== 'newCustomer' && (
                                                <div
                                                    id="new-req-form-left"
                                                    className={`new-req-form-left ${requestSection === 'DCF_ACTION' ? 'increase-margin' : ''
                                                        }`}>
                                                    <div
                                                        onClick={previousWizard}
                                                        tabIndex={0}
                                                        onMouseDown={previousWizard}
                                                        onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyPress(e, previousWizard)}
                                                        className={`direction-arrow-container active ${previousBtnEnablingHandler() ? 'btn-active-shadow' : ''
                                                            } `}
                                                        aria-label="previous"
                                                        role="button">
                                                        <svg className='left-arrow' viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.2197 6.03033C11.9268 5.73744 11.9268 5.26256 12.2197 4.96967C12.5126 4.67678 12.9874 4.67678 13.2803 4.96967L17.7803 9.46967C18.0732 9.76256 18.0732 10.2374 17.7803 10.5303L13.2803 15.0303C12.9874 15.3232 12.5126 15.3232 12.2197 15.0303C11.9268 14.7374 11.9268 14.2626 12.2197 13.9697L16.1893 10L12.2197 6.03033Z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            )}
                                        {(requestSection === 'customer' || requestSection === 'newCustomer') && (
                                            <div className={`new-req-form-left`}></div>
                                        )}
                                        <div
                                            id="new-req-form-body"
                                            className={`new-req-form-body p-b-20 ${requestSection === 'selectDevice' || requestSection === 'action'
                                                ? 'change-width'
                                                : ''
                                                }   ${requestSection === 'preview' ||
                                                    requestSection === 'DCF_ACTION' ||
                                                    requestSection === 'customer' ||
                                                    requestSection === 'newCustomer' ||
                                                    requestSection === 'address'
                                                    ? 'no-padding'
                                                    : ''
                                                } `}>
                                            {(requestSection === 'selectDevice' ||
                                                requestSection === 'action' ||
                                                requestSection === 'DCF_ACTION') && (
                                                    <ul
                                                        className={`list-menu ${requestType === StringConstants.POST_SALES ? 'post-list' : ''
                                                            }`}>
                                                        <li className={`completed `} onClick={onDetailsClicked}>
                                                            <span className="circle-icon">
                                                                {iconGenerator('details', true)}
                                                            </span>
                                                            <span className="circle-txt">
                                                                <Trans>Details</Trans>
                                                            </span>
                                                        </li>

                                                        <li
                                                            onClick={onSelectDeviceClicked}
                                                            className={`${requestSection === 'selectDevice' ? 'active' : ''} ${requestSection === 'action' || requestSection === 'DCF_ACTION'
                                                                ? 'completed'
                                                                : ''
                                                                }`}>
                                                            <span className='circle-icon'>
                                                                {iconGenerator('selectDevice', (requestSection === 'action' || requestSection === 'DCF_ACTION'))}
                                                            </span>
                                                            <span className="circle-txt">
                                                                <Trans>Device</Trans>
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span className='circle-icon'>
                                                                {iconGenerator('action', false)}
                                                            </span>
                                                            <span className="circle-txt">
                                                                <Trans>Action</Trans>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                )}
                                            {requestSection === 'selectDevice' && (
                                                <>
                                                    <SelectDevice
                                                        deviceSelected={deviceSelected}
                                                        modelSelected={modelSelected}
                                                        selectedProductId={selectedProductId}
                                                        modelsList={modelsList}
                                                        selectedModel={selectedModel}
                                                        addToCart={addToCart}
                                                        onCountChange={onCountChange}
                                                        cartHText={cartHText}
                                                    />
                                                    {addModelHText && (
                                                        <Text
                                                            className="helper-txt"
                                                            aria-label="Please select a model of products"
                                                            role="log"
                                                            tabIndex={0}>
                                                            <Trans>Please select a model of products.</Trans>
                                                        </Text>
                                                    )}
                                                    {addProductHText && (
                                                        <Text className="helper-txt">
                                                            <Trans>Please select a product family.</Trans>
                                                        </Text>
                                                    )}
                                                    {cartHText && (
                                                        <Text className="helper-txt">
                                                            <Trans>Please add the number of products.</Trans>
                                                        </Text>
                                                    )}
                                                </>
                                            )}

                                            {requestSection === 'newCustomer' && (
                                                <NewCustomer
                                                    setToggleSearch={setToggleSearch}
                                                    toggleSearch={toggleSearch}
                                                    setCustomerInputType={setCustomerInputType}
                                                    lastSelectedCustomerName={lastSelectedCustomerName}
                                                    setLastSelectedCustomerName={setLastSelectedCustomerName}
                                                    originalSelected={originalSelected}
                                                    setOriginalSelected={setOriginalSelected}
                                                    disabled={disabled}
                                                    setDisabled={setDisabled}
                                                    searchNotFound={searchNotFound}
                                                    setSearchNotFound={setSearchNotFound}
                                                    autoSuggestHText={autoSuggestHText}
                                                    setAutoSuggestHText={setAutoSuggestHText}
                                                    customerSearchInput={customerSearchInput}
                                                    setCustomerSearchInput={setCustomerSearchInput}
                                                    customerSelected={customerSelected}
                                                    setCustomerSelected={setCustomerSelected}
                                                    setFilteredData={setFilteredData}
                                                    customerImpactDescription={customerImpactDescription}
                                                    setCustomerImpactDescription={setCustomerImpactDescription}
                                                    impactsHText={impactsHText}
                                                    setImpactsHText={setImpactsHText}
                                                    accountID={customerAccountID}
                                                    setAccountID={setCustomerAccountID}
                                                    accountIDHText={customerAccountIDHText}
                                                    setAccountIDHText={setCustomerAccountIDHText}
                                                    tpidHText={customerTPIDHText}
                                                    setTPIDHText={setCustomerTPIDHText}
                                                    tpid={customerTPID}
                                                    setTPID={setCustomerTPID}
                                                    custName={customerName}
                                                    setStatus={setMsxStatus}
                                                    status={msxStatus}
                                                    setCustName={setCustomerName}
                                                    setCustNameHText={setCustomerNameHText}
                                                    custNameHText={customerNameHText}
                                                    country={country}
                                                    setCountry={setCountry}
                                                    setCountryHText={setCountryHText}
                                                    countryHText={countryHText}
                                                    revenueRisk={newRevenueRisk}
                                                    setRevenueRisk={setNewRevenueRisk}
                                                    revenueHText={revenueHText}
                                                    revenueValidText={revenueValidText}
                                                    setRevenueHText={setRevenueHText}
                                                    impDevices={newDeviceRisk}
                                                    setImpDevices={setNewDeviceRisk}
                                                    setImpDevicesHText={setImpDevicesHText}
                                                    impDevicesHText={impDevicesHText}
                                                    impDevicesValidText={impDevicesValidText}
                                                    setManualData={setManualData}
                                                    setRequestSection={setRequestSection}
                                                    animateNewCustomer={animateNewCustomer}
                                                    requestType={requestType}
                                                    cssCaseNum={cssCaseNum}
                                                    setCSSCaseNum={setCSSCaseNum}
                                                    setCaseNumHText={setCaseNumHText}
                                                    caseNumHText={caseNumHText}
                                                    countryList={countryList}
                                                    selectedRequestType={selectedRequestType}
                                                    setSelectedRequestType={setSelectedRequestType}
                                                />
                                            )}
                                            {requestSection === 'REVIEW_CUSTOMER' && (
                                                <ReviewCustomer
                                                    cssCaseNum={cssCaseNum}
                                                    setCSSCaseNum={setCSSCaseNum}
                                                    caseNumHText={caseNumHText}
                                                    setCaseNumHText={setCaseNumHText}
                                                    animateReviewCustomer={animateReviewCustomer}
                                                />
                                            )}
                                            {requestSection === 'customer' && (
                                                <Customer
                                                    oppId={msxOpportunityId}
                                                    setOppId={setMsxOpportunityId}
                                                    setcustAltPage={setCustomerAltPage}
                                                    showModal={showModal}
                                                    animateCustomer={animateCustomer}
                                                    requestType={requestType}
                                                    cssCaseNum={cssCaseNum}
                                                    setCSSCaseNum={setCSSCaseNum}
                                                    setCaseNumHText={setCaseNumHText}
                                                    caseNumHText={caseNumHText}
                                                    autoSuggestHText={autoSuggestHText}
                                                    setRevenueRisk={setRevenueRisk}
                                                    setImpDevices={setImpDevices}
                                                    isMSXListDataLoading={isMSXListDataLoading}
                                                    msxData={msxData}
                                                    setMSXMatched={setMSXMatched}
                                                    setMSXNotMatched={setMSXNotMatched}
                                                    // removeDuplicates={removeDuplicates}
                                                    // setSuggestions={setSuggestions}
                                                    // getSuggestionValue={getSuggestionValue}
                                                    // renderSuggestion={renderSuggestion}
                                                    // suggestions={suggestions}
                                                    // dropDownValue={dropDownValue}
                                                    // setDropDownValue={setDropDownValue}
                                                    setFilteredData={setFilteredData}
                                                    setAutoSuggestHText={setAutoSuggestHText}
                                                    msxMatched={msxMatched}
                                                    filteredData={filteredData}
                                                    msxNotMatched={msxNotMatched}
                                                    revenueRisk={revenueRisk}
                                                    setRevenueHText={setRevenueHText}
                                                    setRevenueValidText={setRevenueValidText}
                                                    revenueHText={revenueHText}
                                                    impDevicesValidText={impDevicesValidText}
                                                    revenueValidText={revenueValidText}
                                                    impDevices={impDevices}
                                                    setImpDevicesHText={setImpDevicesHText}
                                                    setImpDevicesValidText={setImpDevicesValidText}
                                                    impDevicesHText={impDevicesHText}
                                                    emailID={emailID}
                                                    setEmailID={setEmailID}
                                                    setEmailValidText={setEmailValidText}
                                                    setEmailHText={setEmailHText}
                                                    emailHtext={emailHText}
                                                    emailValidText={emailValidText}
                                                    setManualData={setManualData}
                                                    setRequestSection={setRequestSection}
                                                    customerSearchInput={customerSearchInput}
                                                    setCustomerSearchInput={setCustomerSearchInput}
                                                    customerSelected={customerSelected}
                                                    setCustomerSelected={setCustomerSelected}
                                                />
                                            )}
                                            {requestSection === 'address' && (
                                                <Address
                                                    custEmail={customerEmail}
                                                    contactNum={contactNum}
                                                    custShippingAddress={customerShippingAddress}
                                                    setAddress={setAddress}
                                                    custEmailHText={customerEmailHText}
                                                    contactNumHtext={contactNumHText}
                                                    custShippingAddHText={customerShippingAddHText}
                                                    contactName={contactName}
                                                    contactNameHText={contactNameHText}
                                                    requestType={requestType}
                                                    setcustAltPage={setCustomerAltPage}
                                                    showModal={showModal}
                                                    animateAddress={animateAddress}
                                                    contactNumPrefix={contactNumPrefix}
                                                    countryList={countryList}
                                                />
                                            )}
                                            {requestSection === 'action' && (
                                                <Action
                                                    tempDateImportanceValue={tempDateImportanceValue}
                                                    animateAction={animateAction}
                                                    dateImportance={dateImportanceToSubmit}
                                                    setDateImportanceHText={setDateImportanceHText}
                                                    msxMatched={msxMatched}
                                                    dateImportanceHText={dateImportanceHText}
                                                    requestType={requestType}
                                                    selectedDate={selectedDate}
                                                    setDateSent={setDateSent}
                                                    setSelectedDate={setSelectedDate}
                                                    selectedIssue={selectedIssue}
                                                    onIssueChange={onIssueChange}
                                                    issueHText={issueHText}
                                                    editorState={editorState}
                                                    setEditorState={setEditorState}
                                                    hashTagsFormatted={hashTagsFormatted}
                                                    setHashTagsFormatted={setHashTagsFormatted}
                                                    setTextToSubmit={setDateImportanceToSubmit}
                                                />
                                            )}
                                            {requestSection === 'DCF_ACTION' && (
                                                <ActionSection
                                                    selectedDCFKey={selectedDCFKey}
                                                    onBtnChange={onBtnChange}
                                                    fundsDescription={fundsDescription}
                                                    setAction={setAction}
                                                    fundHText={fundHText}
                                                    dcfBtnHText={dcfBtnHText}
                                                    animateDCFAction={animateDCFAction}
                                                />
                                            )}

                                            {requestSection === 'attachment' && (
                                                <AddAttachments
                                                    requestType={requestType}
                                                    attachmentList={attachmentList}
                                                    setAttachmentList={setAttachmentList}
                                                    animateAttachments={animateAttachments}
                                                    readyToUploadFiles={readyToUploadFiles}
                                                    setReadyToUploadFiles={setReadyToUploadFiles}
                                                    addToBlobUploadFiles={addToBlobUploadFiles}
                                                    uploadErrors={uploadErrors}
                                                    setUploadErrors={setUploadErrors}
                                                />
                                            )}

                                            {requestSection === 'preview' && (
                                                <>
                                                    <div
                                                        className={`preview  ${animatePreview === 'S_TO_PREV' ? 'prevSlide' : ''} ${animatePreview === 'S_TO_NEXT' ? 'nextSlide' : ''
                                                            } ${animatePreview === 'A_TO_LEFT' ? 'animateToLeft' : ''} ${animatePreview === 'A_TO_RIGHT' ? 'animateToRight' : ''
                                                            }`}>
                                                        <RequestPreview
                                                            prevData={{
                                                                type: requestType,
                                                                title: searchValue,
                                                                desc:
                                                                    requestDescriptionToSubmit.length > 0
                                                                        ? requestDescriptionToSubmit
                                                                        : requestDesc,
                                                                msxMatched: msxMatched,
                                                                filteredData: filteredData,
                                                                dateImportance:
                                                                    dateImportanceToSubmit.length > 0
                                                                        ? dateImportanceToSubmit
                                                                        : dateImportance,
                                                                dueDate: dateSent,
                                                                impDevices: impDevices,
                                                                revenueRisk: revenueRisk,
                                                                productName: selectedProductName,
                                                                emailID: emailID,
                                                                shippingAdd: shippingAdd,
                                                                mobileNumber: mobileNumber,
                                                                custEmail: customerEmail,
                                                                contactNum: contactNum,
                                                                custShippingAddress: customerShippingAddress,
                                                                cssCaseNum: cssCaseNum,
                                                                fundsDescription: fundsDescription,
                                                                selectedDCFKey: selectedDCFKey,
                                                                manualData: manualData,
                                                                status: msxStatus,
                                                                custName: customerName,
                                                                tpid: customerTPID,
                                                                accountID: customerAccountID,
                                                                customerImpactDescription: customerImpactDescription,
                                                                country: country,
                                                                selectedIssue: selectedIssue,
                                                                contactName: contactName,
                                                                newDeviceRisk: newDeviceRisk,
                                                                newRevenueRisk: newRevenueRisk,
                                                                mobilePrefix: mobilePrefix,
                                                                contactNumPrefix: contactNumPrefix
                                                            }}
                                                        />
                                                    </div>
                                                    <Text className="txt-black submitted">
                                                        <Trans>Created by</Trans> : {userDetails}
                                                        {' on '}
                                                        {moment(timestamp).format('D MMMM  YYYY')}
                                                    </Text>
                                                </>
                                            )}

                                            {((selectedModel.filter((item) => item.isAdded === true).length !== 0 && requestSection === 'selectDevice') ||
                                                requestSection === 'preview') && (
                                                    <div
                                                        className={`added-devices ${cartState ? 'animateToRight' : ''}  ${requestSection === 'preview' ? 'cart-preview' : ''
                                                            } `}>
                                                        <h2>
                                                            <Trans>Troubled Devices</Trans>
                                                        </h2>
                                                        {requestSection === 'preview' &&
                                                            !fieldValidation("selectedModel", 'modelCount', selectedModel) && (
                                                                <Text
                                                                    className="more-link"
                                                                    tabIndex={0}
                                                                    onKeyPress={(e: React.KeyboardEvent<HTMLElement>) => keyPress(e, addMoreDevices)}
                                                                    onClick={() => addMoreDevices()}
                                                                    aria-label="Add more devices"
                                                                    role="link">
                                                                    <Trans>+ Add more devices</Trans>
                                                                </Text>
                                                            )}
                                                        {requestSection === 'preview' &&
                                                            fieldValidation("selectedModel", 'modelCount', selectedModel) && (
                                                                <Text
                                                                    className="more-link"
                                                                    tabIndex={0}
                                                                    onKeyPress={(e: React.KeyboardEvent<HTMLElement>) => keyPress(e, addMoreDevices)}
                                                                    onClick={() => addMoreDevices()}
                                                                    aria-label="Add a device"
                                                                    role="link">
                                                                    <Trans>+ Add a device</Trans>{' '}
                                                                </Text>
                                                            )}
                                                        <div className={`added-devices-container`}>
                                                            {deviceSelected && (
                                                                <CartItem
                                                                    selectedModel={selectedModel}
                                                                    onCountChange={onCountChange}
                                                                    removeSelectedModel={removeSelectedModel}
                                                                    requestSection={requestSection}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                            <div className="nvg-button-wrapper">
                                                {(requestSection === 'customer' ||
                                                    requestSection === 'newCustomer' ||
                                                    requestSection === 'attachment' ||
                                                    requestSection === 'preview') && (
                                                        <div className="next-btn-container">
                                                            <Link
                                                                tabIndex={0}
                                                                onClick={onBackLink}
                                                                className={`back-link
                                                        ${requestType === StringConstants.POST_SALES &&
                                                                        requestSection === 'customer'
                                                                        ? `no-float`
                                                                        : ''
                                                                    } `}>
                                                                <Trans>Back</Trans>
                                                            </Link>
                                                        </div>
                                                    )}
                                                {(() => {
                                                    if (
                                                        requestSection === 'attachment' &&
                                                        readyToUploadFiles &&
                                                        attachmentList.length > 0
                                                    ) {
                                                        return (
                                                            <PrimaryButton
                                                                className={'action-next-btn m-t-45 active shadow-active'}
                                                                onClick={handleUploadAttachments}
                                                                disabled={isUplodingToBlob}>
                                                                {isUplodingToBlob ? (
                                                                    <div className="upload-attachment-spinner">
                                                                        <Text className="upload-attachment-spinner-text">
                                                                            Uploading
                                                                        </Text>
                                                                        <Spinner size={SpinnerSize.large} />
                                                                    </div>
                                                                ) : (
                                                                    <Trans>Upload</Trans>
                                                                )}
                                                            </PrimaryButton>
                                                        );
                                                    }
                                                    if (
                                                        (requestSection === 'action' && requestType !== StringConstants.POST_SALES) ||
                                                        (requestSection === 'customer' &&
                                                            requestType !== StringConstants.POST_SALES) ||
                                                        requestSection === 'attachment' ||
                                                        requestSection === 'DCF_ACTION' ||
                                                        requestSection === 'address' ||
                                                        (requestSection === 'newCustomer' &&
                                                            requestType !== StringConstants.POST_SALES)
                                                    ) {
                                                        return (
                                                            <div className="next-btn-styles">
                                                                <PrimaryButton
                                                                    text={translate('Next')}
                                                                    className={`action-next-btn m-t-45 ${nextBtnEnablingHandler() ? 'active shadow-active' : ''
                                                                        }`}
                                                                    onClick={() => {
                                                                        if (requestSection === 'newCustomer') {
                                                                            if (
                                                                                customerName?.trim() === '' ||
                                                                                country?.trim() === '' ||
                                                                                !isNumberGreaterThanZero(
                                                                                    newRevenueRisk
                                                                                        .toString()
                                                                                        .replace('$', '')
                                                                                        .replaceAll(',', '')
                                                                                ) ||
                                                                                newDeviceRisk.trim() === '' ||
                                                                                newDeviceRisk.trim() === '0' ||
                                                                                (requestType === StringConstants.REVIEW_REQUEST &&
                                                                                    cssCaseNum.trim() === '')
                                                                            ) {
                                                                                if (
                                                                                    TEAM_DETAILS[0].id === StringConstants.CSS ||
                                                                                    TEAM_DETAILS[0].id === StringConstants.CXP
                                                                                ) {
                                                                                    setCaseNumHText(cssCaseNum.trim() === '');
                                                                                }
                                                                                customerInputType === 'search'
                                                                                    ? setAutoSuggestHText(
                                                                                        customerName?.trim() === '' ? true : false
                                                                                    )
                                                                                    : setCustomerNameHText(
                                                                                        customerName?.trim() === '' ? true : false
                                                                                    );
                                                                                setCountryHText(
                                                                                    country?.trim() === '' ? true : false
                                                                                );
                                                                                setRevenueHText(
                                                                                    !isNumberGreaterThanZero(
                                                                                        newRevenueRisk
                                                                                            .toString()
                                                                                            .replace('$', '')
                                                                                            .replaceAll(',', '')
                                                                                    )
                                                                                );
                                                                                setImpDevicesHText(
                                                                                    newDeviceRisk.trim() === '' ||
                                                                                    newDeviceRisk.trim() === '0'
                                                                                );

                                                                                setCaseNumHText(
                                                                                    requestType === StringConstants.REVIEW_REQUEST &&
                                                                                    cssCaseNum.trim() === ''
                                                                                );
                                                                            } else {
                                                                                setAnimateNewCustomer('A_TO_RIGHT');
                                                                                setTimeout(() => {
                                                                                    setAnimateAttachments('S_TO_PREV');
                                                                                    setRequestSection('attachment');
                                                                                }, 300);
                                                                            }
                                                                        } else if (requestSection === 'action') {
                                                                            setTempDateImportanceValue(
                                                                                dateImportanceToSubmit.length > 0
                                                                                    ? dateImportanceToSubmit.concat('')
                                                                                    : dateImportance?.concat('')
                                                                            );
                                                                            if (
                                                                                (dateImportance.trim() === '' &&
                                                                                    dateImportanceToSubmit.trim() === '') ||
                                                                                (requestType === 'CSSRequest' &&
                                                                                    selectedIssue === undefined)
                                                                            ) {
                                                                                setIssueHText(
                                                                                    requestType === 'CSSRequest' &&
                                                                                    selectedIssue === undefined
                                                                                );
                                                                                setDateImportanceHText(dateImportance.trim() === '');
                                                                            } else {
                                                                                setAnimateAction('A_TO_RIGHT');
                                                                                setTimeout(() => {
                                                                                    if (requestType === StringConstants.POST_SALES) {
                                                                                        setAnimateDCFAction('S_TO_PREV');
                                                                                        setRequestSection('DCF_ACTION');
                                                                                    } else {
                                                                                        if (manualData) {
                                                                                            setAnimateNewCustomer('S_TO_PREV');
                                                                                            setRequestSection('newCustomer');
                                                                                        } else {
                                                                                            setAnimateCustomer('S_TO_PREV');
                                                                                            setRequestSection('customer');
                                                                                        }
                                                                                    }
                                                                                }, 300);
                                                                            }
                                                                        } else if (requestSection === 'DCF_ACTION') {
                                                                            if (
                                                                                (selectedDCFKey !== 'B' && selectedDCFKey !== 'A') ||
                                                                                (selectedDCFKey === 'A' &&
                                                                                    fundsDescription.trim() === '')
                                                                            ) {
                                                                                setFundHText(
                                                                                    selectedDCFKey === 'A' &&
                                                                                    fundsDescription.trim() === ''
                                                                                );
                                                                                setDCFBtnHText(
                                                                                    selectedDCFKey !== 'B' && selectedDCFKey !== 'A'
                                                                                );
                                                                            } else {
                                                                                setAnimateDCFAction('A_TO_RIGHT');
                                                                                setTimeout(() => {
                                                                                    if (manualData) {
                                                                                        setAnimateNewCustomer('S_TO_PREV');
                                                                                        setRequestSection('newCustomer');
                                                                                    } else {
                                                                                        setAnimateCustomer('S_TO_PREV');
                                                                                        setRequestSection('customer');
                                                                                        setTimeout(() => {
                                                                                            document.getElementById('msx-search-field')?.focus();
                                                                                        }, 300);
                                                                                    }
                                                                                }, 300);
                                                                            }
                                                                        } else if (requestSection === 'customer') {
                                                                            if (
                                                                                !isNumberGreaterThanZero(
                                                                                    revenueRisk
                                                                                        ?.toString()
                                                                                        .replace('$', '')
                                                                                        .replaceAll(',', '')
                                                                                ) ||
                                                                                impDevices?.trim() === '' ||
                                                                                impDevices?.trim() === '0' ||
                                                                                (requestType === StringConstants.REVIEW_REQUEST &&
                                                                                    cssCaseNum.trim() === '')
                                                                            ) {
                                                                                if (
                                                                                    TEAM_DETAILS[0].id === StringConstants.CSS ||
                                                                                    TEAM_DETAILS[0].id === StringConstants.CXP
                                                                                ) {
                                                                                    setCaseNumHText(cssCaseNum.trim() === '');
                                                                                }
                                                                                setAutoSuggestHText(!customerSelected);
                                                                                setRevenueHText(
                                                                                    !isNumberGreaterThanZero(
                                                                                        revenueRisk
                                                                                            ?.toString()
                                                                                            .replace('$', '')
                                                                                            .replaceAll(',', '')
                                                                                    )
                                                                                );
                                                                                setImpDevicesHText(
                                                                                    impDevices?.trim() === '' ||
                                                                                        impDevices?.trim() === '0'
                                                                                        ? true
                                                                                        : false
                                                                                );
                                                                                setEmailValidText(
                                                                                    emailID.trim() !== '' &&
                                                                                        !fieldValidation(
                                                                                            emailID.trim(),
                                                                                            'email',
                                                                                            selectedModel
                                                                                        )
                                                                                        ? true
                                                                                        : false
                                                                                );
                                                                                setCaseNumHText(
                                                                                    requestType === StringConstants.REVIEW_REQUEST &&
                                                                                    cssCaseNum.trim() === ''
                                                                                );
                                                                            } else {
                                                                                setAnimateCustomer('A_TO_RIGHT');
                                                                                setTimeout(function () {
                                                                                    setAnimateAttachments('S_TO_PREV');
                                                                                    setRequestSection('attachment');
                                                                                }, 300);
                                                                                setTimeout(() => {
                                                                                    document.getElementById('add-attachment-container')?.setAttribute("aria-label", "Add an attachment")
                                                                                }, 1000)
                                                                            }
                                                                        } else if (requestSection === 'address') {
                                                                            if (
                                                                                !fieldValidation(
                                                                                    customerEmail.trim(),
                                                                                    'email',
                                                                                    selectedModel
                                                                                ) ||
                                                                                !fieldValidation(
                                                                                    contactNum.trim(),
                                                                                    'mobile number',
                                                                                    selectedModel
                                                                                ) ||
                                                                                customerShippingAddress.trim() === '' ||
                                                                                contactName.trim() === '' ||
                                                                                !contactNumPrefix
                                                                            ) {
                                                                                setContactNameHText(
                                                                                    contactName.trim() === '' ? true : false
                                                                                );
                                                                                setCustomerEmailHText(
                                                                                    !fieldValidation(
                                                                                        customerEmail.trim(),
                                                                                        'email',
                                                                                        selectedModel
                                                                                    )
                                                                                );
                                                                                setContactNumHText(
                                                                                    !fieldValidation(
                                                                                        contactNum.trim(),
                                                                                        'mobile number',
                                                                                        selectedModel
                                                                                    ) || !contactNumPrefix
                                                                                );
                                                                                setCustomerShippingAddHText(
                                                                                    customerShippingAddress.trim() === ''
                                                                                        ? true
                                                                                        : false
                                                                                );
                                                                            } else {
                                                                                setAnimateAddress('A_TO_RIGHT');
                                                                                setTimeout(() => {
                                                                                    setAnimateAttachments('S_TO_PREV');
                                                                                    setRequestSection('attachment');
                                                                                }, 300);
                                                                            }
                                                                        } else if (requestSection === 'attachment') {
                                                                            setAnimateAttachments('A_TO_RIGHT');
                                                                            setTimeout(() => {
                                                                                setCartState(false);
                                                                                setAnimatePreview('S_TO_PREV');
                                                                                setRequestSection('preview');
                                                                                setTimeout(() => {
                                                                                    document.getElementById('request-preview')?.setAttribute("aria-label", "preview request page")
                                                                                }, 500)
                                                                            }, 300);
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                })()}

                                                {requestSection === 'preview' && (
                                                    <>
                                                        {previewHText && (
                                                            <Text className={`helper-txt`}>
                                                                <Trans>No troubled devices found, add troubled devices</Trans>
                                                            </Text>
                                                        )}
                                                        <div className="next-btn-container">
                                                            <PrimaryButton
                                                                onClick={() => {
                                                                    if (!fieldValidation("selectedModel", 'modelCount', selectedModel)) {
                                                                        submitClick();
                                                                    } else {
                                                                        setPreviewHText(true);
                                                                    }
                                                                }}
                                                                className={`${nextBtnEnablingHandler() ? 'active shadow-active' : ''
                                                                    } action-next-btn submit-btn `}
                                                                text={translate('Submit')}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className="new-req-form-right" id="new-req-form-right">
                                            {(requestSection === 'details' ||
                                                requestSection === 'selectDevice' ||
                                                requestSection === 'REVIEW_CUSTOMER' ||
                                                (requestType === StringConstants.POST_SALES && requestSection === 'action') ||
                                                (requestType === StringConstants.POST_SALES &&
                                                    (requestSection === 'customer' || requestSection === 'newCustomer'))) && (
                                                    <div
                                                        tabIndex={0}
                                                        onClick={nextWizard}
                                                        onMouseDown={nextWizard}
                                                        onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyPress(e, nextWizard)}
                                                        className={`direction-arrow-container right-container ${nextBtnEnablingHandler() ? 'active btn-active-shadow' : ''
                                                            }`}
                                                        aria-label="next"
                                                        role="navigation">
                                                        <svg className='right-arrow' viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.2197 6.03033C11.9268 5.73744 11.9268 5.26256 12.2197 4.96967C12.5126 4.67678 12.9874 4.67678 13.2803 4.96967L17.7803 9.46967C18.0732 9.76256 18.0732 10.2374 17.7803 10.5303L13.2803 15.0303C12.9874 15.3232 12.5126 15.3232 12.2197 15.0303C11.9268 14.7374 11.9268 14.2626 12.2197 13.9697L16.1893 10L12.2197 6.03033Z" />
                                                        </svg>
                                                    </div>
                                                )}
                                        </div>
                                        {((requestSection === 'action' && requestType !== StringConstants.POST_SALES) ||
                                            requestSection === 'DCF_ACTION' ||
                                            requestSection === 'address' ||
                                            ((requestSection === 'customer' || requestSection === 'newCustomer') &&
                                                requestType !== StringConstants.POST_SALES)) && (
                                                <div className="new-req-form-right"></div>
                                            )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    ;
                    <Dialog hidden={hideDialog} onDismiss={toggleHideDialog}>
                        {quickLinksChange ? (
                            <div className="row-flex-box justify-center">
                                <Text className="device-error">
                                    All of your current changes will be discarded. Do you want to proceed?
                                </Text>
                                <DialogFooter>
                                    <PrimaryButton
                                        onClick={() => {
                                            toggleHideDialog();
                                            setQuickLinksChange(false);
                                            setTempQuickLinkID(quickLinksID);
                                            goBackToInitial('search');
                                            setOriginalRoutingML(null);
                                            logRequestflowTelemetry(
                                                TelemetryConstants.CANCEL_REQUEST_CLICKED,
                                                {"problem_desc_char_count": String(requestDescriptionToSubmit.length) }
                                            )
                                        }}
                                        text="Ok"
                                    />
                                    <DefaultButton onClick={toggleHideDialog} text="Cancel" />
                                </DialogFooter>
                            </div>
                        ) : (
                            <Spinner size={SpinnerSize.large} label="Please wait, while we redirect you to the right place" />
                        )}
                    </Dialog>
                    <Modal isOpen={isModalOpen} onDismiss={handleMainModalDismiss} isBlocking={customerAltPage || isCreatingRequest} className="modal add-customer-model">
                        {!customerAltPage && !isCreatingRequest && (
                            <LinkRoute
                                tabIndex={0}
                                onClick={() => {
                                    draftSaveRequest(JSON.stringify({}));
                                    history.push(RouteConstants.KNOWLEDGE_PORTAL);
                                }}
                                className="close-btn close-link"
                                to="/knowledge-portal"
                                data-testid="closebtn-test">
                                <Icon iconName="Cancel" />
                            </LinkRoute>
                        )}

                        {customerAltPage && (
                            <AlternateContactDetails
                                emailID={emailID}
                                setEmailValidText={setEmailValidText}
                                setEmailID={setEmailID}
                                emailValidText={emailValidText}
                                mobileNumber={mobileNumber}
                                setMobNumValidText={setMobNumValidText}
                                setMobileNumber={setMobileNumber}
                                mobNumValidText={mobNumValidText}
                                shippingAdd={shippingAdd}
                                setShippingAdd={setShippingAdd}
                                fieldValidation={fieldValidation}
                                selectedModel={selectedModel}
                                hideModal={hideModal}
                                goBackToInitial={goBackToInitial}
                                setInitialState={setInitialState}
                                setAnimateStep={setAnimateStep}
                                setAnimateStepReverse={setAnimateStepReverse}
                                setFullReverse={setFullReverse}
                                setCartState={setCartState}
                                custAltPage={customerAltPage}
                                isCreatingRequest={isCreatingRequest}
                                setcustAltPage={setCustomerAltPage}
                                countryList={countryList}
                                mobilePrefix={mobilePrefix}
                                setMobilePrefix={setMobilePrefix}
                            />
                        )}

                        {isCreatingRequest && (
                            <div className="modal-cont">
                                <Spinner size={SpinnerSize.large} label="Please wait, while we are processing your request" />
                            </div>
                        )}
                        {!isCreatingRequest && !errorMsg && successMsg && (
                            <div className="modal-cont" onLoad={() => {
                                logRequestflowTelemetry(TelemetryConstants.CREATE_NEW_REQUEST, {
                                    "creationTimeInMs": new Date(Date.now() - requestStartTime.current.getTime()).getTime().toString()
                                })
                            }
                            }>
                                <Stack tokens={{ childrenGap: 40 }}>
                                    <Stack tokens={{ childrenGap: 8 }}>
                                        <div className="icon-success">
                                            <svg width="64" height="70" viewBox="0 0 64 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M56.6667 61.6667H37.5593C36.602 63.5033 35.3893 65.1857 33.968 66.6667H56.6667C60.3467 66.6667 63.3333 63.68 63.3333 60V26.0933C63.3333 24.3267 62.63 22.63 61.38 21.38L41.95 1.95333C41.9 1.9035 41.8437 1.86027 41.7877 1.81733C41.746 1.78557 41.705 1.754 41.6667 1.72C41.43 1.50667 41.1967 1.29667 40.9367 1.12C40.8523 1.06313 40.7603 1.01827 40.6683 0.973566C40.615 0.947533 40.5617 0.921566 40.51 0.893333C40.4543 0.861966 40.399 0.8299 40.3433 0.797767C40.1627 0.693233 39.9813 0.588266 39.79 0.506666C39.1333 0.233333 38.4267 0.0966665 37.71 0.0466665C37.6443 0.0424665 37.5793 0.0336002 37.514 0.0247002C37.4237 0.0123668 37.333 0 37.24 0H16.6667C12.9867 0 10 2.98667 10 6.66667V31.6607C11.5806 31.0013 13.256 30.524 15 30.2547V6.66667C15 5.75 15.7467 5 16.6667 5H36.6667V20C36.6667 23.68 39.6533 26.6667 43.3333 26.6667H58.3333V60C58.3333 60.9167 57.5867 61.6667 56.6667 61.6667ZM54.5933 21.6667H43.3333C42.4133 21.6667 41.6667 20.9167 41.6667 20V8.73667L54.5933 21.6667ZM40 51.6667C40 53.3877 39.7993 55.0617 39.4203 56.6667H47.5C50.7217 56.6667 53.3333 54.055 53.3333 50.8333V37.5C53.3333 34.2783 50.7217 31.6667 47.5 31.6667H26.6813C29.9316 33.025 32.7803 35.1523 35 37.8213V36.6667H47.5C47.9603 36.6667 48.3333 37.0397 48.3333 37.5V41.6667H37.5593C38.3747 43.231 39.0047 44.9073 39.4203 46.6667H48.3333V50.8333C48.3333 51.2937 47.9603 51.6667 47.5 51.6667H40ZM36.6667 51.6667C36.6667 61.792 28.4586 70 18.3333 70C8.2081 70 0 61.792 0 51.6667C0 41.5413 8.2081 33.3333 18.3333 33.3333C28.4586 33.3333 36.6667 41.5413 36.6667 51.6667ZM29.5118 43.8213C28.861 43.1707 27.8057 43.1707 27.1548 43.8213L15 55.9763L9.51183 50.488C8.86097 49.8373 7.8057 49.8373 7.15483 50.488C6.50393 51.139 6.50393 52.1943 7.15483 52.8453L13.8215 59.512C14.4724 60.1627 15.5276 60.1627 16.1785 59.512L29.5118 46.1787C30.1627 45.5277 30.1627 44.4723 29.5118 43.8213Z" fill="#107C10" />
                                            </svg>

                                        </div>
                                        <Text className="heading"><Trans>Request Submitted Successfully!</Trans></Text>
                                    </Stack>

                                    <Stack tokens={{ childrenGap: 24 }}>
                                        <StackItem>
                                            <Text className="text">
                                                <Trans>
                                                    You have successfully created a new request with ID{' '}
                                                    <Text className="new-skp-id">{postSKPId}</Text> for{' '}
                                                    <Text className="customer-info">
                                                        {manualData
                                                            ? customerName + ' ' + country
                                                            : [filteredData[0]?.accountName, filteredData[0]?.country].join(', ')}
                                                    </Text>
                                                </Trans>
                                            </Text>
                                            <Text className="text">
                                                <Trans>The recently added requests can be viewed under</Trans>{' '}
                                                <LinkRoute
                                                    tabIndex={0}
                                                    onClick={() => goBackToInitial('new request')}
                                                    className="unif-dashboard-link"
                                                    to={`/unified-dashboard/${postSKPId}`}>
                                                    <Trans>My Requests</Trans>
                                                </LinkRoute>{' '}
                                                <Trans>on the unified dashboard</Trans>
                                            </Text>
                                        </StackItem>
                                        <hr />
                                        {/* Feedback capture component */}
                                        <RequestFeedback
                                            requestId={postSKPId}
                                            onSubmitted={(details: RequestFeedbackSubmittedDetails) => {
                                                setFeedbackSubmitted(true);
                                                appInsightsService.logEvent('FeedbackSubmitted', {
                                                    requestId: String(postSKPId),
                                                    experience: String(details?.reaction ?? ''),
                                                    submissionType: String(details?.hasComment ? 'experience+comments' : 'experience-only'),
                                                    commentLength: String(details?.commentLength ?? 0),
                                                });
                                            }}
                                        />
                                    </Stack>
                                </Stack>
                            </div>
                        )}
                        {errorMsg && (
                            <div>
                            <div className="modal-cont">
                                    <div className="error-icon">
                                        <Image src={errorIcon} alt="Error" />
                                    </div>
                                    <Text className="heading">
                                        <Trans>An error occurred while creating a request, please try again</Trans>
                                    </Text>
                                    <Text className="text">
                                        <Link
                                            tabIndex={0}
                                            onClick={() => {
                                                hideModal();
                                                goBackToInitial('new request');
                                                setInitialState();
                                                setAnimateStep('');
                                                setAnimateStepReverse('');
                                                setFullReverse(true);
                                                setCartState(false);
                                                logRequestflowTelemetry(TelemetryConstants.INITIATE_NEW_REQUEST, {
                                                    "errorPreviously": String(true)
                                                })
                                            }}>
                                            <Trans>Create a New Request</Trans>
                                        </Link>
                                    </Text>
                                </div>
                                <LinkRoute to="/" className="new-req-link go-to-home-link">
                                    <Trans>Go to home</Trans>
                                </LinkRoute>
                            </div>
                        )}
                    </Modal>
                    <Dialog hidden={hideCancelConfirmationDialog} onDismiss={toggleCancelConfirmationDialog}>
                        <div className="row-flex-box justify-center">
                            <Text className="device-error">
                                All of your current changes will be discarded. Do you want to proceed?
                            </Text>
                            <DialogFooter>
                                <PrimaryButton
                                    onClick={() => {
                                        setIsCancelClicked(true);
                                        logRequestflowTelemetry(
                                            TelemetryConstants.CANCEL_REQUEST_CLICKED,
                                            (currentSection === StringConstants.DESCRIPTION) ? { "TextPresent": String(requestDescriptionToSubmit === "") } : {}
                                        )
                                    }}
                                    text="Ok"
                                />
                                <DefaultButton onClick={toggleCancelConfirmationDialog} text="Cancel" />
                            </DialogFooter>
                        </div>
                    </Dialog>
                </div>
            </div>
        );
};

/**
 * This Hook handles closing the useSearchSuggestionClose  on clicking outside of the useSearchSuggestion container
 */
const useSearchSuggestionClose = (ref: React.RefObject<HTMLDivElement>, handleSuggestionClose: () => void) => {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                handleSuggestionClose();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleSuggestionClose, ref]);
};

export default RequestExperience;